{
  "401": {
    "title": "غير مصرح لك بالوصول إلى هذه الصفحة.",
    "text": "إذا كنت تعتقد أن هذا غير صحيح، يرجى التواصل مع المسؤول",
    "back_button": "العودة إلى لوحة التحكم"
  },
  "403": {
    "title": "ليس لديك إذن للوصول إلى هذه الصفحة.",
    "text": "إذا كنت تعتقد أن هذا خطأ، يرجى التواصل مع المسؤول.",
    "back_button": "العودة إلى لوحة التحكم"
  },
  "404": {
    "title": "لم يتم العثور على هذه الصفحة.",
    "text": "تعذر العثور على الصفحة المطلوبة.",
    "back_button": "العودة إلى لوحة التحكم"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "تسجيل الخروج",
    "account": "الحساب",
    "profile": "الملف الشخصي",
    "hello": "مرحباً",
    "home": "الرئيسية",
    "loading": "جارٍ التحميل...",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "view": "عرض",
    "save": "حفظ",
    "records": "السجلات",
    "add": "إضافة",
    "read": "قراءة",
    "write": "حفظ",
    "edit": "تعديل",
    "new": "جديد",
    "delete": "حذف",
    "actions": "الإجراءات",
    "active": "نشط",
    "inactive": "غير نشط",
    "search": "بحث",
    "select": "تحديد",
    "none": "بلا",
    "yes": "نعم",
    "no": "لا",
    "years": "سنوات",
    "months": "أشهر",
    "favorites": "المفضلة",
    "reports": "التقارير",
    "recordsPerPage": "عدد السجلات في الصفحة",
    "changePassword": "تغيير كلمة المرور",
    "longDateFormat": "{years} سنة و {months} شهر",
    "importData": "استيراد البيانات",
    "upload": "رفع",
    "downloadTemplate": "تنزيل القالب",
    "selectOption": "اختر خياراً",
    "id": "المعرّف",
    "translations": "الترجمات",
    "or": "أو",
    "review": "مراجعة",
    "approve": "اعتماد",
    "reject": "رفض",
    "reviewComments": "تعليقات المراجعة",
    "reviewOnBehalfOf": "المراجعة نيابة عن",
    "reviewed": "تمت المراجعة",
    "reviewedBy": "تمت المراجعة بواسطة ",
    "pending": "قيد الانتظار",
    "approved": "معتمد",
    "rejected": "مرفوض",
    "skipped": "تم التخطي",
    "warning": "تحذير",
    "manager": "المدير",
    "move": "نقل",
    "leave": "إجازة",
    "export": "تصدير",
    "import": "استيراد",
    "next": "التالي",
    "previous": "السابق",
    "done": "تم",
    "run": "تشغيل",
    "form": "النموذج",
    "status": "الحالة",
    "emailTemplate": "قالب البريد الإلكتروني",
    "send": "إرسال",
    "saving": "جارٍ الحفظ...",
    "saved": "تم الحفظ",
    "loadData": "تحميل البيانات",
    "download": "تنزيل",
    "noData": "لا توجد بيانات متاحة في الجدول",
    "cropImage": "قص الصورة",
    "selectImageToCrop": "اختر صورة لقصها",
    "selectImage": "اختر صورة",
    "list": "قائمة",
    "group": "مجموعة",
    "attach": "إرفاق",
    "exportCsv": "تصدير CSV",
    "auditFields": "حقول التدقيق",
    "saveDisplayOrder": "حفظ ترتيب العرض",
    "permissionActions": {
      "read": "قراءة",
      "write": "كتابة",
      "delete": "حذف",
      "execute": "تنفيذ"
    },
    "messages": {
      "personNotFound": "لم يتم العثور على الشخص. يرجى التواصل مع المسؤول.",
      "notRegisteredSessionOnly": "أنت غير مسجل في JTP، لذا سيتم تطبيق هذا التغيير على جلستك الحالية فقط. يرجى التواصل مع المسؤول لإضافتك.",
      "formUnsavedChanges": "لديك تغييرات غير محفوظة. هل أنت متأكد أنك تريد الإغلاق؟",
      "serverError": "خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً أو التواصل مع مسؤول النظام.",
      "networkError": "تعذر الاتصال بالخادم. تحقق من اتصالك بالإنترنت أو تواصل مع مسؤول النظام.",
      "forbidden": "ليس لديك إذن للوصول إلى هذا المورد. تواصل مع مسؤول النظام إذا كنت تعتقد أن هذا خطأ.",
      "fileUploadError": "خطأ أثناء رفع الملف. تحقق من صيغة الملف وحجمه وحاول مرة أخرى.",
      "fileUploadSuccessEmail": "تم رفع الملف بنجاح. سيتم إرسال بريد إلكتروني بنتيجة الاستيراد قريباً.",
      "failedLoadPermissions": "فشل تحميل صلاحيات المستخدم. يرجى تحديث الصفحة أو التواصل مع مسؤول النظام.",
      "downloadingFile": "جارٍ تنزيل الملف...",
      "fileDownloadError": "خطأ أثناء تنزيل الملف. يرجى المحاولة مرة أخرى أو التواصل مع مسؤول النظام.",
      "fileImportedSuccessfully": "تم استيراد الملف بنجاح.",
      "invalidFileFormat": "صيغة الملف غير صالحة. يرجى التحقق من الملف والمحاولة مرة أخرى.",
      "exportFailed": "فشل تصدير البيانات. يرجى المحاولة مرة أخرى أو التواصل مع مسؤول النظام.",
      "unableGetPermissions": "تعذر على JTP الحصول على صلاحياتك. يمكنك العمل بصلاحية وصول أساسية حتى يتم حل هذه المشكلة"
    },
    "warnings": {
      "maxDisplayedRecords": "يتم عرض {shown} سجل من أصل {filtered}. لعرض سجلات إضافية، استخدم وظيفة البحث."
    },
    "info": {
      "dragAndDropInfo": "اسحب وأفلت أي شخص لتنظيم الشجرة"
    },
    "validation": {
      "required": "هذا الحقل مطلوب.",
      "email": "يرجى إدخال عنوان بريد إلكتروني صالح.",
      "minValue": "يجب أن تكون القيمة {min} على الأقل.",
      "maxValue": "لا يمكن أن تكون القيمة أكبر من {max}.",
      "minLength": "يجب أن تتكون القيمة من {min} حرفاً على الأقل.",
      "maxLength": "لا يمكن أن تتجاوز القيمة {max} حرفاً.",
      "onlyIntegers": "يجب أن تكون القيمة عدداً صحيحاً.",
      "invalidDate": "التاريخ المُدخل غير صالح.",
      "dateAfterOrEqual": "يجب أن يكون التاريخ بعد أو مساوياً لـ {date}"
    },
    "baseAuditableEntity": {
      "createdBy": "أُنشئ بواسطة",
      "createdDate": "تاريخ الإنشاء",
      "modifiedBy": "عُدّل بواسطة",
      "modifiedDate": "تاريخ التعديل"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "داخلي",
      "2": "خارجي"
    },
    "readinessFactor": {
      "0": "غير متاح",
      "1": "جاهز الآن",
      "2": "جاهز بالتطوير (1-2 سنة)",
      "3": "جاهز بالتطوير (2-3 سنوات)",
      "4": "بديل طارئ"
    },
    "positionType": {
      "1": "شراء",
      "2": "تصنيع",
      "3": "بيع",
      "4": "دعم"
    },
    "personStatus": {
      "1": "نشط",
      "2": "غير نشط",
      "3": "منتهي الخدمة"
    },
    "communicationPriority": {
      "1": "عادية",
      "2": "عالية"
    },
    "personTypes": {
      "0": "غير معروف",
      "1": "موظف براتب",
      "2": "متعاقد",
      "3": "مورّد",
      "4": "موظف بالساعة",
      "5": "خارجي",
      "6": "DU بالساعة غير نشط",
      "7": "DU براتب غير نشط",
      "8": "DU سائق شاحنة",
      "9": "تنفيذي",
      "10": "نقابي",
      "11": "غير نقابي",
      "12": "نقابي محتمل",
      "13": "براتب غير معفى",
      "14": "بالساعة",
      "15": "DU إجازة مدفوعة",
      "17": "سائق شاحنة",
      "18": "DU إجازة غير مدفوعة",
      "19": "إفراج عن العمل",
      "20": "وصول خارجي - المستوى الأول",
      "21": "وصول خارجي - المستوى الثاني",
      "22": "وصول خارجي - المستوى الثالث",
      "23": "وصول خارجي - المستوى الرابع",
      "24": "وصول خارجي - المستوى الخامس",
      "99": "موظف عالمي"
    },
    "customerSpecificStatus": {
      "0": "غير معروف",
      "1": "نشط",
      "2": "غير نشط",
      "3": "مساعدة دخل",
      "4": "إجازة بدون راتب",
      "5": "متقاعد",
      "6": "منسحب"
    },
    "resourceType": {
      "1": "تطبيق",
      "2": "وحدة",
      "3": "صفحة",
      "4": "قسم الصفحة",
      "5": "إجراء الصفحة",
      "6": "حقل الصفحة",
      "7": "بيانات"
    },
    "securityResourceAction": {
      "0": "بلا",
      "1": "قراءة",
      "2": "كتابة",
      "3": "قراءة وكتابة",
      "4": "تنفيذ",
      "5": "قراءة وتنفيذ",
      "6": "كتابة وتنفيذ",
      "7": "قراءة وكتابة وتنفيذ",
      "8": "حذف",
      "9": "قراءة وحذف",
      "10": "كتابة وحذف",
      "11": "قراءة وكتابة وحذف",
      "12": "تنفيذ وحذف",
      "13": "قراءة وتنفيذ وحذف",
      "14": "كتابة وتنفيذ وحذف",
      "15": "الكل"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "وضع المحور",
        "groups": "مجموعات الصفوف",
        "rowGroupColumnsEmptyMessage": "اسحب هنا لتعيين مجموعات الصفوف",
        "values": "القيم",
        "valueColumnsEmptyMessage": "اسحب هنا للتجميع",
        "pivots": "تسميات الأعمدة",
        "pivotColumnsEmptyMessage": "اسحب هنا لتعيين تسميات الأعمدة",
        "columns": "الأعمدة",
        "filters": "المرشحات",
        "loadingOoo": "جارٍ التحميل...",
        "noRowsToShow": "لا توجد صفوف لعرضها",
        "enabled": "مفعّل",
        "group": "مجموعة",
        "footerTotal": "الإجمالي",
        "filterOoo": "تصفية...",
        "searchOoo": "بحث...",
        "blanks": "(فارغ)",
        "selectAll": "(تحديد الكل)",
        "selectAllSearchResults": "(تحديد جميع نتائج البحث)",
        "noMatches": "لا توجد تطابقات",
        "equals": "يساوي",
        "notEqual": "لا يساوي",
        "blank": "فارغ",
        "notBlank": "غير فارغ",
        "lessThan": "أقل من",
        "greaterThan": "أكبر من",
        "lessThanOrEqual": "أقل من أو يساوي",
        "greaterThanOrEqual": "أكبر من أو يساوي",
        "inRange": "بين",
        "inRangeStart": "من",
        "inRangeEnd": "إلى",
        "contains": "يحتوي على",
        "notContains": "لا يحتوي على",
        "startsWith": "يبدأ بـ",
        "endsWith": "ينتهي بـ",
        "before": "قبل",
        "after": "بعد",
        "andCondition": "و",
        "orCondition": "أو",
        "applyFilter": "تطبيق",
        "resetFilter": "إعادة تعيين",
        "clearFilter": "مسح",
        "cancelFilter": "إلغاء",
        "textFilter": "مرشح نصي",
        "numberFilter": "مرشح رقمي",
        "dateFilter": "مرشح تاريخ",
        "setFilter": "مرشح مجموعة",
        "pinColumn": "تثبيت العمود",
        "pinLeft": "تثبيت لليسار",
        "pinRight": "تثبيت لليمين",
        "noPin": "بدون تثبيت",
        "valueAggregation": "تجميع القيم",
        "noAggregation": "بلا",
        "autosizeThisColumn": "ضبط حجم هذا العمود تلقائياً",
        "autosizeAllColumns": "ضبط حجم جميع الأعمدة تلقائياً",
        "groupBy": "تجميع حسب",
        "ungroupBy": "إلغاء التجميع حسب",
        "ungroupAll": "إلغاء تجميع الكل",
        "addToValues": "إضافة {'${variable}'} إلى القيم",
        "removeFromValues": "إزالة {'${variable}'} من القيم",
        "addToLabels": "إضافة {'${variable}'} إلى التسميات",
        "removeFromLabels": "إزالة {'${variable}'} من التسميات",
        "resetColumns": "إعادة تعيين الأعمدة",
        "expandAll": "توسيع جميع مجموعات الصفوف",
        "collapseAll": "طي جميع مجموعات الصفوف",
        "copy": "نسخ",
        "copyWithHeaders": "نسخ مع الرؤوس",
        "copyWithGroupHeaders": "نسخ مع رؤوس المجموعات",
        "cut": "قص",
        "paste": "لصق",
        "export": "تصدير",
        "csvExport": "تصدير CSV",
        "excelExport": "تصدير Excel",
        "sum": "المجموع",
        "first": "الأول",
        "last": "الأخير",
        "min": "الحد الأدنى",
        "max": "الحد الأقصى",
        "count": "العدد",
        "avg": "المتوسط",
        "average": "المتوسط",
        "filteredRows": "تمت التصفية",
        "selectedRows": "المحدد",
        "totalRows": "إجمالي الصفوف",
        "totalAndFilteredRows": "الصفوف"
      },
      "noFilterMessage": "لا توجد مرشحات لهذا التقرير",
      "noAccessReport": "ليس لديك صلاحية لعرض هذا التقرير. يرجى التواصل مع مسؤول النظام إذا كنت تعتقد أن هذا خطأ.",
      "pdfSizeErrorMessage": "حجم ملف PDF كبير جداً ولا يمكن عرضه.",
      "pdfMaxSizeDownloaded": "التقرير كبير جداً لعرضه. تحقق من مجلد التنزيلات لديك.",
      "failedLoadReports": "فشل تحميل التقارير. ستعمل الميزات الأخرى كالمعتاد. يرجى تحديث الصفحة أو التواصل مع مسؤول النظام إذا استمرت المشكلة.",
      "run": "تشغيل",
      "download": "تنزيل",
      "viewFilter": {
        "button": "عرض المرشحات...",
        "title": "المعاملات",
        "name": "الاسم",
        "value": "القيمة"
      },
      "fullScreen": "شاشة كاملة...",
      "smallScreen": "شاشة صغيرة...",
      "tabButton": {
        "fullScreen": "إخفاء قسم المعاملات",
        "smallScreen": "إظهار قسم المعاملات",
        "about": "حول",
        "downloadExcel": "تنزيل ملف Excel",
        "clear": "إغلاق جميع علامات التبويب"
      },
      "modalAbout": {
        "title": "حول",
        "description": "الوصف",
        "version": "الإصدار",
        "reference": "المرجع",
        "lastChange": "آخر تغيير",
        "dataSource": "مصدر البيانات"
      }
    },
    "maintenance": {
      "menuName": "التقارير",
      "pageTitle": "التقارير",
      "id": "المعرّف",
      "title": "العنوان",
      "reference": "المرجع",
      "directoryTree": "شجرة المجلدات",
      "directoryTreeHelp": "استخدم الشرطة المائلة العكسية للفصل بين المجلدات، مثال: التقارير\\المالية\\الشهرية",
      "reportType": "نوع التقرير",
      "typeGrid": "جدول",
      "typeForm": "نموذج",
      "securityResource": "مورد الأمان",
      "description": "الوصف",
      "versionNumber": "الإصدار",
      "isActive": "نشط",
      "lastModified": "آخر تعديل",
      "isSchedulable": "قابل للجدولة",
      "isArchivable": "قابل للأرشفة",
      "isAuditable": "قابل للتدقيق",
      "passMultiValue": "تمرير القيم المتعددة كنص",
      "expireInDays": "ينتهي خلال (أيام)",
      "add": "إضافة تقرير",
      "edit": "تعديل التقرير",
      "delete": {
        "title": "حذف التقرير",
        "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
      },
      "messages": {
        "created": "تم إنشاء التقرير بنجاح.",
        "updated": "تم حفظ التقرير بنجاح.",
        "deleted": "تم حذف التقرير بنجاح.",
        "imported": "تم استيراد التقرير بنجاح."
      },
      "sections": {
        "main": "الخصائص الرئيسية",
        "parameters": "المعاملات",
        "sqls": "جمل SQL",
        "grids": "جداول النتائج",
        "models": "نماذج التقرير"
      },
      "sql": {
        "add": "إضافة جملة SQL",
        "edit": "تعديل جملة SQL",
        "description": "الوصف",
        "connection": "الاتصال",
        "multipleResultset": "مجموعات نتائج متعددة",
        "sql": "SQL",
        "generateGrids": "إنشاء الجداول من SQL",
        "generateGridsSuccess": "تم إنشاء الجدول بنجاح. راجعه في علامة تبويب جداول النتائج.",
        "delete": {
          "title": "حذف جملة SQL",
          "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
        }
      },
      "grid": {
        "add": "إضافة جدول",
        "edit": "تعديل الجدول",
        "label": "التسمية",
        "resultsetNumber": "رقم مجموعة النتائج",
        "parentGrid": "الجدول الأصل",
        "defaultGroupedColumns": "الأعمدة المجمّعة الافتراضية",
        "relationString": "سلسلة العلاقة",
        "delete": {
          "title": "حذف الجدول",
          "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
        }
      },
      "column": {
        "add": "إضافة عمود",
        "edit": "تعديل العمود",
        "columnName": "اسم العمود",
        "label": "التسمية",
        "header": "الرأس",
        "dataType": "نوع البيانات",
        "sumarizeType": "التلخيص",
        "showOrder": "الترتيب",
        "mask": "القناع",
        "helpText": "نص المساعدة",
        "template": "القالب",
        "delete": {
          "title": "حذف العمود",
          "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
        }
      },
      "param": {
        "add": "إضافة معامل",
        "edit": "تعديل المعامل",
        "displayOrder": "الترتيب",
        "name": "الاسم",
        "nameValidation": "يُسمح فقط بالحروف والأرقام والشرطات السفلية.",
        "label": "التسمية",
        "dataType": "نوع البيانات",
        "defaultValue": "القيمة الافتراضية",
        "helpText": "نص المساعدة",
        "required": "مطلوب",
        "multiple": "قيم متعددة",
        "width": "العرض (أعمدة)",
        "enumValues": "القيم (مفصولة بفاصلة منقوطة)",
        "enumValuesHelp": "مثال: 1;2;3",
        "enumLabels": "التسميات (مفصولة بفاصلة منقوطة)",
        "enumLabelsHelp": "مثال: الخيار أ;الخيار ب;الخيار ج",
        "sql": "استعلام SQL",
        "generate": "إنشاء المعاملات من SQL",
        "delete": {
          "title": "حذف المعامل",
          "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
        }
      },
      "model": {
        "add": "إضافة نموذج",
        "edit": "تعديل النموذج",
        "description": "الوصف",
        "order": "الترتيب",
        "connection": "الاتصال",
        "file": "ملف النموذج (.trdx / .trdp)",
        "fileLoaded": "تم تحميل الملف بنجاح.",
        "delete": {
          "title": "حذف النموذج",
          "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
        }
      },
      "paramDataType": {
        "text": "نص",
        "number": "رقم",
        "date": "تاريخ",
        "time": "وقت",
        "combo": "قائمة منسدلة",
        "boolean": "منطقي",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "نص",
        "number": "رقم",
        "date": "تاريخ",
        "time": "وقت",
        "combo": "قائمة منسدلة",
        "boolean": "منطقي"
      },
      "sumarizeType": {
        "nosumarize": "بلا",
        "sum": "المجموع",
        "min": "الحد الأدنى",
        "max": "الحد الأقصى",
        "average": "المتوسط",
        "count": "العدد"
      },
      "import": {
        "connection": "تجاوز الاتصال",
        "connectionHelp": "اختياري: تجاوز جميع مراجع الاتصال في الملف المستورد."
      }
    }
  },
  "file": {
    "description": "الوصف",
    "files": "الملفات",
    "editDescription": "تعديل الوصف",
    "delete": "حذف الملف",
    "download": "تنزيل الملف",
    "pendingUpload": "الرفع معلّق. سيتم حفظ الملف فقط بعد النقر على 'حفظ'.",
    "noFiles": "لم تتم إضافة أي ملفات."
  },
  "dashboard": {
    "menuTitle": "لوحة التحكم",
    "title": "لوحة التحكم",
    "addWidget": "إضافة عنصر واجهة",
    "editLayout": "تعديل التخطيط",
    "saveLayout": "حفظ التخطيط",
    "importLayout": "استيراد التخطيط",
    "exportLayout": "تصدير التخطيط",
    "category": "الفئة",
    "widget": "عنصر الواجهة",
    "widgetTitle": "العنوان",
    "widgetParameters": "المعاملات",
    "widgetInformation": "معلومات عنصر الواجهة",
    "noParameters": "لا توجد معاملات لعنصر الواجهة هذا.",
    "delete": "حذف عنصر الواجهة",
    "viewLink": "عرض",
    "noItemsToDisplay": "لا توجد عناصر لعرضها",
    "messages": {
      "saveSuccess": "تم حفظ التخطيط بنجاح.",
      "importSuccess": "تم استيراد التخطيط بنجاح.",
      "exportSuccess": "تم تصدير التخطيط بنجاح.",
      "importFailed": "فشل استيراد التخطيط.",
      "widgetNotFound": "لم يتم العثور على عنصر الواجهة",
      "failedToLoad": "فشل التحميل",
      "noDataAvailable": "لا توجد بيانات متاحة",
      "noParametersConfigured": "لا توجد معاملات مهيأة لعنصر الواجهة هذا."
    },
    "tutorial": {
      "mainMessage": "مرحباً بك في لوحة التحكم الخاصة بك! استخدم الأزرار أعلاه لتخصيصها.",
      "callToAction": "أرني كيف!",
      "instructions": {
        "add": {
          "title": "زر إضافة عنصر واجهة",
          "description": "هنا يمكنك العثور على عناصر الواجهة حسب الفئة. قد يحتوي بعضها على معاملات تتيح لك تخصيص لوحة التحكم بالكامل. لا تنسَ النقر على حفظ بعد إضافة جميع عناصر الواجهة."
        },
        "edit": {
          "title": "تعديل تخطيط عناصر الواجهة",
          "description": "هنا يمكنك تغيير لوحة التحكم الخاصة بك: إضافة أو إزالة عناصر الواجهة، ونقلها وتغيير حجمها. لا تنسَ النقر على حفظ بعد التعديل."
        },
        "import": {
          "title": "استيراد التخطيط",
          "description": "باستخدام ملف نسخة احتياطية، يمكنك استيراده هنا. ملاحظة: سيتم استبدال لوحة التحكم الخاصة بك."
        },
        "export": {
          "title": "تصدير التخطيط",
          "description": "بمجرد اكتمال لوحة التحكم الخاصة بك، يمكنك تصديرها للاحتفاظ بنسخة احتياطية أو إرسالها إلى مستخدم آخر لنسخ لوحة التحكم الخاصة بك."
        }
      }
    }
  },
  "communication": {
    "title": "الاتصالات",
    "menuTitle": "الاتصالات",
    "menuName": "الاتصالات",
    "markAsRead": "تحديد كمقروء",
    "subject": "الموضوع",
    "date": "التاريخ",
    "priority": "الأولوية",
    "backToInbox": "العودة إلى صندوق الوارد",
    "noMessages": "لا توجد رسائل في صندوق الوارد الخاص بك.",
    "status": "الحالة",
    "read": "مقروء",
    "unread": "غير مقروء",
    "edit": "عرض",
    "messages": {
      "markedAsRead": "تم الاطلاع على الاتصال"
    }
  },
  "settings": {
    "title": "الإعدادات",
    "theme": {
      "name": "المظهر",
      "dark": "داكن",
      "light": "فاتح"
    }
  },
  "userInfo": {
    "title": "معلومات المستخدم",
    "permissions": "الصلاحيات",
    "userName": "اسم المستخدم",
    "fullName": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "employeeId": "رقم الموظف",
    "action": "الإجراء",
    "permissionCode": "رمز الصلاحية"
  },
  "profile": {
    "title": "ملفي الشخصي",
    "menuName": "الملف الشخصي",
    "score": "درجة الملف الشخصي",
    "managerWarning": "المعلومات المقدمة في صفحة 'ملفي الشخصي' متاحة للمدراء وقسم الموارد البشرية في المؤسسة لأغراض تخطيط المواهب.",
    "photo": "تغيير الصورة",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "manager": "المدير",
    "position": "المنصب",
    "plant": "المصنع",
    "businessArea": "مجال العمل",
    "degreeType": "الدرجة العلمية",
    "degreeName": "اسم الدرجة العلمية أو الشهادة هنا",
    "language": "اللغات",
    "languagesInfo": "حدد جميع اللغات التي تتحدث بها",
    "geoMobility": {
      "label": "التنقل الجغرافي",
      "none": "بلا",
      "local": "محلي",
      "national": "وطني",
      "international": "دولي",
      "nationalAndInternational": "وطني ودولي"
    },
    "businessMobility": "التنقل بين وحدات الأعمال",
    "skills": "مهاراتي",
    "skillsInfo": "حدد مجالات خبرتك",
    "careerInterests": "الاهتمامات المهنية",
    "careerAspirations": "الطموحات المهنية",
    "jobHistory": "السجل الوظيفي ذو الصلة",
    "save": "حفظ",
    "invalidPhotoFormat": "صيغة الملف غير مدعومة. يرجى استخدام PNG أو JPEG.",
    "photoCrop": {
      "title": "صورة الملف الشخصي",
      "selectImage": "رفع",
      "confirm": "تطبيق",
      "cancel": "إلغاء",
      "deletePhoto": "إزالة",
      "hint": "اسحب لإعادة التموضع. قرّب أو باعد للتكبير.",
      "emptyState": "لم يتم تحديد صورة. انقر على \"رفع\" للبدء."
    },
    "messages": {
      "saved": "تم حفظ الملف الشخصي بنجاح",
      "notRegistered": "أنت غير مسجل في JTP. يرجى التواصل مع الموارد البشرية لإضافتك. حتى ذلك الحين، سيكون وصولك مقيداً."
    }
  },
  "impersonate": {
    "title": "انتحال هوية مستخدم",
    "userName": "تسجيل الدخول",
    "start": "بدء الانتحال",
    "messages": {
      "impersonationStarted": "بدأت جلسة الانتحال. للعودة إلى حسابك، يرجى تسجيل الخروج وتسجيل الدخول مرة أخرى.",
      "userNotFound": "لم يتم العثور على المستخدم. يرجى التحقق من اسم المستخدم والمحاولة مرة أخرى."
    }
  },
  "about": {
    "menuName": "حول",
    "title": "حول"
  },
  "releaseNotes": {
    "menuName": "ملاحظات الإصدار",
    "title": "ملاحظات الإصدار",
    "name": "الاسم",
    "version": "الإصدار",
    "description": "الوصف",
    "appType": "نوع التطبيق",
    "releaseDate": "تاريخ الإصدار",
    "messages": {
      "notFound": "لم يتم العثور على ملاحظة الإصدار.",
      "saveError": "خطأ أثناء حفظ ملاحظة الإصدار. يرجى المحاولة مرة أخرى لاحقاً."
    }
  },
  "help": {
    "menuTitle": "المساعدة",
    "externalLinkMessage": "أنت على وشك فتح رابط خارجي:",
    "externalLinkConfirm": "فتح الرابط",
    "lastUpdated": "آخر تحديث: {date}",
    "wasThisHelpful": "هل كان هذا مفيداً؟",
    "helpful": "مفيد",
    "notHelpful": "غير مفيد",
    "pageModal": {
      "title": "مساعدة لهذه الصفحة",
      "intro": "تقدم لك مقالات المساعدة إرشادات حول الصفحة التي تتواجد بها. اختر إحداها لفتحها، أو أغلق هذه النافذة."
    }
  },
  "admin": {
    "menuTitle": "الإدارة",
    "appCustomizations": {
      "menuName": "تخصيصات التطبيق",
      "pageTitle": "تخصيصات التطبيق",
      "imageLogos": "شعارات الصور",
      "headerLogo": "شعار الرأس",
      "menuLogo": "شعار القائمة",
      "bannerImage": "صورة اللافتة",
      "upload": "رفع",
      "remove": "إزالة",
      "noCustom": "الصورة الافتراضية",
      "preview": "معاينة",
      "messages": {
        "saved": "تم حفظ التخصيصات بنجاح.",
        "invalidKey": "مفتاح الشعار غير صالح.",
        "invalidLanguage": "رمز اللغة غير صالح.",
        "fileRequired": "الملف مطلوب.",
        "fileTooLarge": "يتجاوز حجم الملف الحد الأقصى المسموح به وهو 2 ميجابايت.",
        "fileTypeNotAllowed": "نوع الملف غير مسموح به. استخدم PNG أو JPEG أو WebP.",
        "notFound": "لم يتم العثور على التخصيص."
      }
    },
    "help": {
      "menuName": "المساعدة",
      "pageTitle": "المساعدة",
      "title": "العنوان",
      "description": "الوصف",
      "isActive": "نشط",
      "isMenuDisplayed": "إظهار في القائمة",
      "isMenuDisplayedInfo": "عند التعطيل، يتم إخفاء هذه المساعدة من قائمة المساعدة، لكن يمكن فتحها من أيقونة المساعدة في الصفحات المرتبطة بها.",
      "isTrackingEnabled": "تفعيل التتبع",
      "isTrackingEnabledInfo": "عند التفعيل، يتم تسجيل مشاهدات الصفحة لكل موظف ويظهر تقييم \"هل كان هذا مفيداً\" في صفحة المساعدة.",
      "viewCount": "المشاهدات",
      "viewCountValue": "شوهدت {views} مرة من قبل {viewers} شخصاً",
      "viewCountInfo": "العدد الإجمالي للمشاهدات وعدد الموظفين المختلفين الذين فتحوا هذه المساعدة.",
      "helpfulCount": "مفيد",
      "notHelpfulCount": "غير مفيد",
      "displayOrder": "ترتيب العرض",
      "securityResources": "موارد الأمان",
      "securityResourcesInfo": "قائمة بالصلاحيات مفصولة بفواصل. اتركها فارغة لإتاحتها للجميع؛ وإلا يجب أن يمتلك المستخدم واحدة على الأقل من الصلاحيات المدرجة.",
      "associatedMenus": "الصفحات المرتبطة",
      "associatedMenusInfo": "أرفق هذه المساعدة بصفحة واحدة أو أكثر حتى يمكن فتحها مباشرة من أيقونة المساعدة في تلك الصفحات.",
      "addMenu": "إضافة صفحة",
      "add": "إضافة مساعدة",
      "edit": "تعديل المساعدة",
      "delete": {
        "title": "حذف المساعدة",
        "text": "هل أنت متأكد أنك تريد حذف إدخال المساعدة هذا؟"
      },
      "messages": {
        "created": "تم إنشاء المساعدة بنجاح.",
        "updated": "تم تحديث المساعدة بنجاح.",
        "deleted": "تم حذف المساعدة بنجاح.",
        "notFound": "لم يتم العثور على المساعدة."
      }
    },
    "menuHierarchy": {
      "menuName": "التسلسل الهرمي للقائمة",
      "pageTitle": "التسلسل الهرمي للقائمة",
      "displayName": "اسم العرض",
      "displayNameKey": "هل هذا؟؟؟؟",
      "route": "المسار",
      "routeParam": "معامل القائمة",
      "securityResources": "موارد الأمان",
      "children": "القوائم الفرعية",
      "isActive": "نشط",
      "icon": "الأيقونة",
      "iconHelpText": "مكتبة الأيقونات",
      "displayOrder": "ترتيب العرض",
      "edit": "تعديل عنصر القائمة",
      "messages": {
        "success": "تم حفظ عنصر القائمة بنجاح."
      }
    },
    "notificationTemplate": {
      "menuName": "قالب الإشعار",
      "pageTitle": "قالب الإشعار",
      "name": "الاسم",
      "parent": "القالب الأصل",
      "parentInfo": "يمكن استخدام القوالب التي تبدأ بـ masterTemplate فقط كقالب أصل.",
      "pushNotificationEnabled": "تفعيل الإشعار الفوري",
      "pushRoute": "مسار الإشعار الفوري",
      "sqlQuery": "استعلام SQL",
      "sqlQueryDateFormatInfo": "يجب تنسيق أعمدة التاريخ بصيغة mm/DD/yyyy.",
      "generalSection": "المعلومات العامة",
      "emailSection": "إشعار البريد الإلكتروني",
      "emailSubject": "موضوع البريد الإلكتروني",
      "emailBody": "نص البريد الإلكتروني (HTML)",
      "pushSection": "الإشعار الفوري",
      "pushSubject": "موضوع الإشعار الفوري",
      "pushBody": "نص الإشعار الفوري",
      "overrideNotificationTemplate": "استبدال القالب الحالي",
      "add": "إضافة قالب",
      "edit": "تعديل القالب",
      "delete": {
        "title": "حذف القالب",
        "text": "هل أنت متأكد أنك تريد حذف القالب \"{name}\"؟"
      },
      "attachment": {
        "title": "إرفاق ملف",
        "attachment": "المرفق",
        "attach": "إرفاق",
        "noAttachedFile": "لم تتم إضافة مرفق...",
        "messages": {
          "uploadedSuccessfully": "تم رفع المرفق بنجاح."
        },
        "delete": {
          "title": "حذف المرفق",
          "text": "هل أنت متأكد أنك تريد حذف المرفق \"{name}\"؟"
        }
      },
      "messages": {
        "created": "تم إنشاء قالب الإشعار بنجاح.",
        "updated": "تم تحديث قالب الإشعار بنجاح.",
        "deleted": "تم حذف قالب الإشعار بنجاح.",
        "alreadyExists": "يوجد بالفعل قالب إشعار بهذا الاسم.",
        "fileRequired": "الملف مطلوب.",
        "importError": "حدث خطأ أثناء استيراد قالب الإشعار.",
        "notFound": "لم يتم العثور على قالب الإشعار."
      }
    },
    "department": {
      "menuName": "القسم",
      "pageTitle": "القسم",
      "externalId": "المعرّف الخارجي",
      "name": "الاسم",
      "isActive": "نشط",
      "add": "إضافة قسم",
      "edit": "تعديل القسم",
      "delete": {
        "title": "حذف القسم",
        "text": "هل أنت متأكد أنك تريد حذف هذا القسم؟"
      },
      "messages": {
        "created": "تم إنشاء القسم بنجاح.",
        "updated": "تم تحديث القسم بنجاح.",
        "deleted": "تم حذف القسم بنجاح."
      }
    },
    "businessArea": {
      "menuName": "مجال العمل",
      "pageTitle": "مجال العمل",
      "id": "المعرّف",
      "externalId": "المعرّف الخارجي",
      "description": "الوصف",
      "calendarId": "التقويم",
      "isActive": "نشط",
      "edit": "تعديل مجال العمل",
      "messages": {
        "created": "تم إنشاء مجال العمل بنجاح.",
        "updated": "تم تحديث مجال العمل بنجاح.",
        "deleted": "تم حذف مجال العمل بنجاح."
      }
    },
    "businessUnit": {
      "menuName": "وحدة الأعمال",
      "pageTitle": "وحدة الأعمال",
      "id": "المعرّف",
      "externalId": "المعرّف الخارجي",
      "description": "الوصف",
      "isActive": "نشط",
      "edit": "تعديل وحدة الأعمال",
      "messages": {
        "created": "تم إنشاء وحدة الأعمال بنجاح.",
        "updated": "تم تحديث وحدة الأعمال بنجاح.",
        "deleted": "تم حذف وحدة الأعمال بنجاح.",
        "inUse": "سجل وحدة الأعمال قيد الاستخدام. احذف استخداماته أولاً.",
        "notFound": "لم يتم العثور على سجل وحدة الأعمال"
      },
      "add": "إضافة وحدة أعمال",
      "delete": {
        "title": "حذف وحدة الأعمال",
        "text": "هل أنت متأكد أنك تريد حذف وحدة الأعمال هذه؟"
      }
    },
    "division": {
      "menuName": "الشعبة",
      "pageTitle": "الشعبة",
      "id": "المعرّف",
      "externalId": "المعرّف الخارجي",
      "description": "الوصف",
      "isActive": "نشط",
      "businessUnitId": "وحدة الأعمال",
      "edit": "تعديل الشعبة",
      "messages": {
        "created": "تم إنشاء الشعبة بنجاح.",
        "updated": "تم تحديث الشعبة بنجاح.",
        "deleted": "تم حذف الشعبة بنجاح."
      },
      "add": "إضافة شعبة",
      "delete": {
        "title": "حذف الشعبة",
        "text": "هل أنت متأكد أنك تريد حذف هذه الشعبة؟"
      }
    },
    "organization": {
      "menuName": "المنظمة",
      "pageTitle": "المنظمة",
      "id": "المعرّف",
      "externalId": "المعرّف الخارجي",
      "name": "الاسم",
      "plantAreaId": "منطقة المصنع",
      "organizationParentId": "المنظمة الأم",
      "edit": "تعديل المنظمة",
      "messages": {
        "created": "تم إنشاء المنظمة بنجاح.",
        "updated": "تم تحديث المنظمة بنجاح.",
        "deleted": "تم حذف المنظمة بنجاح."
      },
      "add": "إضافة منظمة",
      "delete": {
        "title": "حذف المنظمة",
        "text": "هل أنت متأكد أنك تريد حذف هذه المنظمة؟"
      }
    },
    "plant": {
      "menuName": "المصنع",
      "pageTitle": "المصنع",
      "id": "المعرّف",
      "name": "الاسم",
      "alias": "الاسم المستعار",
      "isActive": "نشط",
      "divisionId": "الشعبة",
      "countryId": "الدولة",
      "employeeCanUpdateGoals": "يمكن للموظف تحديث الأهداف",
      "employeeCanUpdateTracks": "يمكن للموظف تحديث الفعلي",
      "employeeCanIncludeKPI": "يمكن للموظف إنشاء مؤشر أداء",
      "managerCanUpdateGoals": "يمكن للمدير تحديث الأهداف",
      "managerCanUpdateTracks": "يمكن للمدير تحديث الفعلي",
      "managerCanIncludeKPI": "يمكن للمدير إنشاء مؤشر أداء",
      "edit": "تعديل المصنع",
      "messages": {
        "created": "تم إنشاء المصنع بنجاح.",
        "updated": "تم تحديث المصنع بنجاح.",
        "deleted": "تم حذف المصنع بنجاح.",
        "inUse": "سجل المصنع قيد الاستخدام. احذف استخداماته أولاً.",
        "notFound": "لم يتم العثور على سجل المصنع",
        "duplicated": "يوجد بالفعل مصنع بهذا الاسم المستعار."
      },
      "add": "إضافة مصنع",
      "delete": {
        "title": "حذف المصنع",
        "text": "هل أنت متأكد أنك تريد حذف هذا المصنع؟"
      }
    },
    "personnelArea": {
      "menuName": "منطقة شؤون الموظفين",
      "pageTitle": "منطقة شؤون الموظفين",
      "id": "المعرّف",
      "description": "الوصف",
      "externalId": "المعرّف الخارجي",
      "plantId": "المصنع",
      "isActive": "نشط",
      "sourceModifiedDate": "تاريخ تعديل المصدر",
      "edit": "تعديل منطقة شؤون الموظفين",
      "messages": {
        "created": "تم إنشاء منطقة شؤون الموظفين بنجاح.",
        "updated": "تم تحديث منطقة شؤون الموظفين بنجاح.",
        "deleted": "تم حذف منطقة شؤون الموظفين بنجاح.",
        "inUse": "سجل منطقة شؤون الموظفين قيد الاستخدام. احذف استخداماته أولاً.",
        "notFound": "لم يتم العثور على سجل منطقة شؤون الموظفين",
        "alreadyExists": "توجد بالفعل منطقة شؤون موظفين بهذا الوصف.",
        "fileRequired": "الملف مطلوب.",
        "importError": "حدث خطأ أثناء استيراد منطقة شؤون الموظفين.",
        "invalidPlant": "معرّف المصنع غير صالح",
        "duplicateExternalId": "المعرّف الخارجي مكرر",
        "importSuccess": "تم استيراد منطقة شؤون الموظفين بنجاح. ستصلك رسالة بالملف عبر البريد الإلكتروني",
        "exportSuccess": "تم تصدير منطقة شؤون الموظفين بنجاح. ستصلك رسالة بالملف عبر البريد الإلكتروني",
        "exportFailed": "فشل تصدير منطقة شؤون الموظفين.",
        "importFailed": "فشل استيراد منطقة شؤون الموظفين.",
        "personNotFound": "لم يتم العثور على الشخص لإجراء الاستيراد. يرجى التواصل مع المسؤول.",
        "emailNotFound": "لم يتم العثور على البريد الإلكتروني لإجراء الاستيراد. يرجى التواصل مع المسؤول.",
        "importFalied": "فشل استيراد منطقة شؤون الموظفين."
      },
      "add": "إضافة منطقة شؤون موظفين",
      "delete": {
        "title": "حذف منطقة شؤون الموظفين",
        "text": "هل أنت متأكد أنك تريد حذف منطقة شؤون الموظفين هذه؟"
      }
    },
    "position": {
      "menuName": "المنصب",
      "pageTitle": "المنصب",
      "id": "المعرّف",
      "description": "الوصف",
      "externalId": "المعرّف الخارجي",
      "active": "نشط",
      "jobCode": "الوظيفة",
      "jobId": "الوظيفة",
      "organizationId": "المنظمة",
      "employeeSubGroupId": "المجموعة الفرعية للموظف",
      "costCenterId": "مركز التكلفة",
      "salaryLevelId": "المستوى الوظيفي",
      "businessAreaId": "مجال العمل",
      "bonusFrequencyId": "تكرار المكافأة",
      "personnelAreaCode": "منطقة شؤون الموظفين",
      "payGradeType": "نوع الدرجة الوظيفية",
      "payGradeArea": "نطاق الدرجة الوظيفية",
      "employeeGroupId": "مجموعة الموظف",
      "salaryGroupId": "مجموعة الراتب",
      "minimum": "الحد الأدنى",
      "midpoint": "نقطة الوسط",
      "edit": "تعديل منطقة المنصب",
      "messages": {
        "created": "تم إنشاء المنصب بنجاح.",
        "updated": "تم تحديث المنصب بنجاح.",
        "inUse": "سجل المنصب قيد الاستخدام. احذف استخداماته أولاً.",
        "notFound": "لم يتم العثور على سجل المنصب",
        "duplicated": "يوجد بالفعل منصب بنفس المعرّف الخارجي/الاسم."
      },
      "add": "إضافة منصب"
    },
    "configuration": {
      "menuName": "الإعدادات",
      "pageTitle": "الإعدادات",
      "key": "المفتاح",
      "value": "القيمة",
      "editorType": "النوع",
      "add": "إضافة إعداد",
      "edit": "تعديل الإعداد",
      "delete": {
        "title": "حذف الإعداد",
        "text": "هل أنت متأكد أنك تريد حذف هذا الإعداد؟"
      },
      "messages": {
        "created": "تم إنشاء الإعداد بنجاح.",
        "updated": "تم تحديث الإعداد بنجاح.",
        "deleted": "تم حذف الإعداد بنجاح."
      },
      "types": {
        "text": "نص",
        "string": "نص",
        "number": "رقم",
        "int": "عدد صحيح",
        "boolean": "منطقي"
      }
    },
    "positionProfile": {
      "pageTitle": "المنصب الحرج",
      "globalCritical": "حرج عالمياً",
      "countryCritical": "حرج على مستوى الدولة",
      "businessUnitCritical": "حرج على مستوى وحدة الأعمال",
      "positionType": "نوع المنصب",
      "sucessorType": "نوع الخلف",
      "potentialSuccessorType": "نوع الخلف",
      "potentialSuccessorId": "الخلف المحتمل",
      "readinessFactor": "عامل الجاهزية",
      "potentialSuccessorName": "الاسم",
      "potentialSuccessorCompany": "الشركة",
      "potentialSuccessorLinkedIn": "رابط LinkedIn",
      "potentialSuccessorNotes": "ملاحظات",
      "messages": {
        "created": "تم إنشاء المنصب الحرج بنجاح.",
        "updated": "تم تحديث المنصب الحرج بنجاح."
      }
    },
    "widget": {
      "menuName": "عنصر الواجهة",
      "pageTitle": "عنصر الواجهة",
      "name": "الاسم",
      "description": "الوصف",
      "securityResources": "موارد الأمان",
      "link": "الرابط",
      "query": "استعلام SQL",
      "queryRequired": "استعلام SQL مطلوب.",
      "sqlQueryDateFormatInfo": "يجب تنسيق أعمدة التاريخ بصيغة mm/DD/yyyy.",
      "minHeight": "الحد الأدنى للارتفاع",
      "minWidth": "الحد الأدنى للعرض",
      "autoApplied": "تطبيق على جميع لوحات التحكم",
      "autoAppliedHelp": "سيؤدي هذا إلى فرض عنصر الواجهة هذا على جميع لوحات التحكم، وسيستمر المستخدمون في رؤيته حتى لو حاولوا إزالته.",
      "type": "النوع",
      "category": "الفئة",
      "add": "إضافة عنصر واجهة",
      "edit": "تعديل عنصر الواجهة",
      "delete": {
        "title": "حذف عنصر الواجهة",
        "text": "هل أنت متأكد أنك تريد حذف عنصر الواجهة هذا؟"
      },
      "examples": {
        "viewSQLExamples": "عرض أمثلة SQL",
        "general": "عام",
        "generalDescription": "بشكل افتراضي، يوفر النظام المعاملات التالية، والتي يمكن الإشارة إليها مباشرة في أي استعلام SQL لعنصر الواجهة.",
        "loggedUserNameDescription": "اسم مستخدم تسجيل الدخول للمستخدم الحالي (مثال: {email}).",
        "loggedUserEmployeeIdDescription": "معرّف الموظف للمستخدم الحالي.",
        "loggedUserLanguageDescription": "رمز لغة المستخدم الحالي (مثال: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "المعرّف الفريد للمستخدم (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "المعرّف الفريد المشفّر للمستخدم",
        "listDescription": "يمثل كل صف عنصراً واحداً في القائمة.",
        "numberDescription": "يُرجع قيمة رقمية واحدة.",
        "donutDescription": "يجب أن تتطابق التسميات والقيم حسب الموضع.",
        "lineDescription": "يمثل كل صف سلسلة خطية واحدة."
      },
      "messages": {
        "created": "تم إنشاء عنصر الواجهة بنجاح.",
        "updated": "تم تحديث عنصر الواجهة بنجاح.",
        "deleted": "تم حذف عنصر الواجهة بنجاح.",
        "fileRequired": "الملف مطلوب.",
        "importError": "حدث خطأ أثناء استيراد عنصر الواجهة.",
        "queryVariablesMissing": "المتغيرات التالية مفقودة في استعلام عنصر الواجهة: \"{variables}\". يرجى إضافتها إلى الاستعلام لضمان عمله بشكل صحيح."
      }
    },
    "reportColumnTemplate": {
      "menuName": "قوالب أعمدة التقارير",
      "pageTitle": "قوالب أعمدة التقارير",
      "id": "المعرّف",
      "description": "الوصف",
      "template": "القالب",
      "templateHelp": "استخدم {value} كعنصر نائب لقيمة الخلية. يُدعم HTML.",
      "add": "إضافة قالب",
      "edit": "تعديل القالب",
      "delete": {
        "title": "حذف القالب",
        "text": "هل أنت متأكد أنك تريد حذف \"{name}\"؟"
      },
      "messages": {
        "created": "تم إنشاء القالب بنجاح.",
        "updated": "تم تحديث القالب بنجاح.",
        "deleted": "تم حذف القالب بنجاح."
      }
    },
    "widgetCategory": {
      "menuName": "فئة عنصر الواجهة",
      "pageTitle": "فئة عنصر الواجهة",
      "name": "الاسم",
      "description": "الوصف",
      "type": "النوع",
      "add": "إضافة فئة عنصر واجهة",
      "edit": "تعديل فئة عنصر الواجهة",
      "delete": {
        "title": "حذف فئة عنصر الواجهة",
        "text": "هل أنت متأكد أنك تريد حذف فئة عنصر الواجهة هذه؟"
      },
      "messages": {
        "created": "تم إنشاء فئة عنصر الواجهة بنجاح.",
        "updated": "تم تحديث فئة عنصر الواجهة بنجاح.",
        "deleted": "تم حذف فئة عنصر الواجهة بنجاح."
      }
    },
    "widgetType": {
      "menuName": "نوع عنصر الواجهة",
      "pageTitle": "نوع عنصر الواجهة",
      "name": "الاسم",
      "types": {
        "number": "رقم",
        "list": "قائمة",
        "donut": "دائري",
        "line": "خطي"
      }
    },
    "widgetParameter": {
      "menuName": "معامل عنصر الواجهة",
      "menuTitle": "معامل عنصر الواجهة",
      "title": "معامل عنصر الواجهة",
      "name": "الاسم",
      "nameInfo": "الاسم المستخدم لتحديد المعامل في استعلام SQL لعنصر الواجهة. لا تستخدم مسافات أو أحرفاً خاصة.",
      "nameUniqueError": "يوجد بالفعل معامل عنصر واجهة بهذا الاسم.",
      "description": "الوصف",
      "isRequired": "مطلوب؟",
      "isMultiple": "متعدد؟",
      "status": "الحالة",
      "edit": "تعديل معامل عنصر الواجهة",
      "add": "إضافة معامل عنصر واجهة",
      "type": "النوع",
      "data": "استعلام SQL",
      "dataInfo": "يجب أن يُرجع استعلام SQL عمودين باسم 'Value' و'Text'.",
      "listOfValues": "قائمة القيم",
      "addValue": "إضافة قيمة",
      "value": "القيمة",
      "label": "التسمية",
      "delete": {
        "title": "حذف معامل عنصر الواجهة",
        "text": "هل أنت متأكد أنك تريد حذف {name}؟"
      },
      "types": {
        "text": "نص",
        "number": "رقم",
        "date": "تاريخ",
        "boolean": "منطقي",
        "select": "قائمة",
        "sql": "قائمة استعلام"
      },
      "messages": {
        "notFound": "لم يتم العثور على معامل عنصر الواجهة.",
        "saveSuccess": "تم حفظ معامل عنصر الواجهة بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ معامل عنصر الواجهة.",
        "deleteSuccess": "تم حذف معامل عنصر الواجهة بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف معامل عنصر الواجهة.",
        "isInUse": "لا يمكن حذف معامل عنصر الواجهة لأنه قيد الاستخدام."
      }
    },
    "people": {
      "menuName": "الأشخاص",
      "pageTitle": "الأشخاص",
      "edit": "تعديل الشخص",
      "employeeId": "رقم الموظف",
      "person": "الشخص",
      "id": "المعرّف",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "externalId": "المعرّف الخارجي",
      "status": "الحالة",
      "type": "النوع",
      "positionShortDescription": "الوصف المختصر للمنصب",
      "hireDate": "تاريخ التعيين",
      "culture": "الثقافة",
      "sourceJTPInstance": "رمز نسخة JTP المصدر",
      "documentId": "رقم المستند",
      "manager": "المدير",
      "position": "المنصب",
      "bonusFrequency": "تكرار المكافأة",
      "businessArea": "مجال العمل",
      "personnelArea": "منطقة شؤون الموظفين",
      "division": "الشعبة",
      "plant": "المصنع",
      "businessUnit": "وحدة الأعمال",
      "shiftId": "الوردية",
      "plantAreaId": "منطقة المصنع",
      "immigrationTypeId": "نوع الهجرة",
      "customerSpecificStatus": "الحالة الخاصة بالعميل",
      "vendorNumber": "رقم المورّد",
      "accountNumber": "آخر 4 أرقام من رقم الحساب",
      "overrideManagerId": "تجاوز المدير",
      "saipAllocation": "تخصيص SAIP",
      "requirePrivacyConsent": "موظف عالمي",
      "globalDirectReports": "المرؤوسون المباشرون العالميون",
      "globalManagerOverrideHelpText": "سيرفع الموظفون المحددون تقاريرهم إلى هذا الموظف فقط على النطاق العالمي. إذا كان لدى هذا الموظف مرؤوسون مباشرون، فسيتم وضع علامة عالمية عليهم جميعاً أيضاً",
      "messages": {
        "updated": "تم تحديث الشخص بنجاح.",
        "notFound": "لم يتم العثور على سجل الشخص",
        "alreadyExists": "يوجد بالفعل شخص بهذا الوصف.",
        "fileRequired": "الملف مطلوب.",
        "importError": "حدث خطأ أثناء استيراد الأشخاص.",
        "importSuccess": "تم استيراد الأشخاص بنجاح. ستصلك رسالة بالملف عبر البريد الإلكتروني",
        "importFailed": "فشل استيراد الأشخاص.",
        "personNotFound": "لم يتم العثور على الشخص لإجراء الاستيراد. يرجى التواصل مع المسؤول.",
        "emailNotFound": "لم يتم العثور على البريد الإلكتروني لإجراء الاستيراد. يرجى التواصل مع المسؤول.",
        "importFalied": "فشل استيراد الأشخاص."
      },
      "personTypes": {
        "unknown": "غير معروف",
        "salariedEmployee": "موظف براتب",
        "contractor": "متعاقد",
        "vendor": "مورّد",
        "hourlyEmployee": "موظف بالساعة",
        "external": "خارجي",
        "duHourlyInactive": "DU بالساعة غير نشط",
        "duSalariedInactive": "DU براتب غير نشط",
        "duTruckDriverIn": "DU سائق شاحنة",
        "executive": "تنفيذي",
        "union": "نقابي",
        "nonUnion": "غير نقابي",
        "unionPossible": "نقابي محتمل",
        "salariedNonExempt": "براتب غير معفى",
        "hourly": "بالساعة",
        "duPaidLeave": "DU إجازة مدفوعة",
        "truckDriver": "سائق شاحنة",
        "duUnpaidLeave": "DU إجازة غير مدفوعة",
        "workRelease": "إفراج عن العمل",
        "externalAccessLevelOne": "وصول خارجي - المستوى الأول",
        "externalAccessLevelTwo": "وصول خارجي - المستوى الثاني",
        "externalAccessLevelThree": "وصول خارجي - المستوى الثالث",
        "externalAccessLevelFour": "وصول خارجي - المستوى الرابع",
        "externalAccessLevelFive": "وصول خارجي - المستوى الخامس",
        "globalEmployee": "موظف عالمي"
      },
      "customerSpecificStatuses": {
        "unknown": "غير معروف",
        "active": "نشط",
        "inactive": "غير نشط",
        "incomeAssistance": "مساعدة دخل",
        "lOA": "إجازة بدون راتب",
        "retiree": "متقاعد",
        "withdrawn": "منسحب"
      }
    },
    "companyCode": {
      "menuName": "رموز الشركة"
    },
    "costCenter": {
      "menuName": "مراكز التكلفة"
    },
    "currency": {
      "menuName": "العملات"
    },
    "exchangeRate": {
      "menuName": "أسعار الصرف"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "تقييم 360",
    "questionOption": {
      "menuTitle": "مقاييس التقييم",
      "pageTitle": "مقاييس التقييم",
      "description": "الوصف",
      "add": "إضافة مقياس تقييم",
      "edit": "تعديل مقياس التقييم",
      "delete": {
        "title": "حذف مقياس التقييم",
        "text": "هل أنت متأكد أنك تريد حذف مقياس التقييم هذا؟"
      },
      "messages": {
        "notFound": "لم يتم العثور على مقياس التقييم.",
        "saveSuccess": "تم حفظ مقياس التقييم بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ مقياس التقييم.",
        "deleteSuccess": "تم حذف مقياس التقييم بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف مقياس التقييم.",
        "isInUse": "لا يمكن حذف مقياس التقييم لأنه قيد الاستخدام.",
        "duplicateName": "يوجد بالفعل مقياس تقييم بهذا الوصف."
      },
      "options": {
        "title": "الخيارات",
        "value": "القيمة",
        "description": "الوصف",
        "explanation": "الشرح",
        "itemOrder": "الترتيب",
        "color": "اللون",
        "commentConfig": "إعدادات التعليق",
        "add": "إضافة خيار",
        "edit": "تعديل الخيار",
        "delete": {
          "title": "حذف الخيار",
          "text": "هل أنت متأكد أنك تريد حذف هذا الخيار؟"
        },
        "messages": {
          "created": "تم إنشاء الخيار بنجاح.",
          "updated": "تم تحديث الخيار بنجاح.",
          "deleted": "تم حذف الخيار بنجاح.",
          "notFound": "لم يتم العثور على الخيار.",
          "duplicateValue": "يوجد خياران أو أكثر بنفس القيمة. يجب أن يكون لكل خيار قيمة فريدة.",
          "duplicateDescription": "يوجد خياران أو أكثر بنفس الوصف. يجب أن يكون لكل خيار وصف فريد."
        },
        "commentConfigType": {
          "followForm": "اتباع النموذج",
          "required": "مطلوب",
          "notRequired": "غير مطلوب"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "مجموعات الأسئلة",
      "pageTitle": "مجموعات الأسئلة",
      "name": "الاسم",
      "description": "الوصف",
      "add": "إضافة مجموعة أسئلة",
      "edit": "تعديل مجموعة الأسئلة",
      "delete": {
        "title": "حذف مجموعة الأسئلة",
        "text": "هل أنت متأكد أنك تريد حذف مجموعة الأسئلة هذه: {name}؟"
      },
      "messages": {
        "notFound": "لم يتم العثور على مجموعة الأسئلة.",
        "saveSuccess": "تم حفظ مجموعة الأسئلة بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ مجموعة الأسئلة.",
        "deleteSuccess": "تم حذف مجموعة الأسئلة بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف مجموعة الأسئلة.",
        "isInUse": "لا يمكن حذف مجموعة الأسئلة لأنها قيد الاستخدام."
      }
    },
    "question": {
      "menuTitle": "الأسئلة",
      "pageTitle": "الأسئلة",
      "name": "الاسم",
      "weight": "الوزن",
      "commentDisabled": "التعليق معطّل",
      "description": "الوصف",
      "questionGroup": "مجموعة الأسئلة",
      "questionOption": "مقياس التقييم",
      "add": "إضافة سؤال",
      "edit": "تعديل السؤال",
      "delete": {
        "title": "حذف السؤال",
        "text": "هل أنت متأكد أنك تريد حذف هذا السؤال؟"
      },
      "messages": {
        "notFound": "لم يتم العثور على السؤال.",
        "saveSuccess": "تم حفظ السؤال بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ السؤال.",
        "deleteSuccess": "تم حذف السؤال بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف السؤال.",
        "isInUse": "لا يمكن حذف السؤال لأنه قيد الاستخدام."
      }
    },
    "formCategory": {
      "menuTitle": "فئات النماذج",
      "pageTitle": "فئات النماذج",
      "name": "الاسم",
      "description": "الوصف",
      "add": "إضافة فئة نموذج",
      "edit": "تعديل فئة النموذج",
      "delete": {
        "title": "حذف فئة النموذج",
        "text": "هل أنت متأكد أنك تريد حذف فئة النموذج هذه؟"
      },
      "messages": {
        "notFound": "لم يتم العثور على فئة النموذج.",
        "saveSuccess": "تم حفظ فئة النموذج بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ فئة النموذج.",
        "deleteSuccess": "تم حذف فئة النموذج بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف فئة النموذج.",
        "isInUse": "لا يمكن حذف فئة النموذج لأنها قيد الاستخدام."
      }
    },
    "formDelegate": {
      "menuTitle": "مفوّض النموذج",
      "pageTitle": "مفوّض النموذج",
      "form": "النموذج",
      "manager": "المدير",
      "delegate": "المفوَّض",
      "add": "إضافة مفوّض نموذج",
      "edit": "تعديل مفوّض النموذج",
      "delegatedToPerson": "التفويض إلى",
      "invitedEnabled": "الدعوة مفعّلة",
      "signEnabled": "التوقيع مفعّل",
      "resultViewerEnabled": "عارض النتائج مفعّل",
      "delete": {
        "title": "حذف مفوّض النموذج",
        "text": "هل أنت متأكد أنك تريد حذف مفوّض النموذج هذا؟"
      },
      "messages": {
        "notFound": "لم يتم العثور على مفوّض النموذج.",
        "saveSuccess": "تم حفظ مفوّض النموذج بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ مفوّض النموذج.",
        "deleteSuccess": "تم حذف مفوّض النموذج بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف مفوّض النموذج.",
        "managerDisabledMessage": "ليس لديك صلاحية الوصول إلى هذا النموذج"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "مفوّض النموذج العالمي",
      "pageTitle": "مفوّض النموذج العالمي"
    },
    "form": {
      "menuTitle": "النماذج",
      "pageTitle": "النماذج",
      "id": "المعرّف",
      "description": "الوصف",
      "category": "الفئة",
      "categoryId": "الفئة",
      "stage": {
        "label": "المرحلة",
        "preparation": "التحضير",
        "execution": "التنفيذ",
        "managerReview": "مراجعة المدير",
        "participantReview": "مراجعة المشارك",
        "closed": "مغلق"
      },
      "active": "نشط",
      "maximumHireDate": "الحد الأقصى لتاريخ التعيين",
      "maxPeopleEvaluateAlert": "تنبيه الحد الأقصى لعدد الأشخاص المُقيَّمين",
      "includeGlobalReporting": "التقارير العالمية",
      "customerSpecificStatus": "الحالة الخاصة بالعميل",
      "employeeType": "نوع الموظف",
      "reportType": {
        "label": "نوع التقرير",
        "question": "حسب السؤال",
        "questionGroup": "حسب مجموعة الأسئلة"
      },
      "directReportBox": "المرؤوس المباشر",
      "selfEvaluationBox": "التقييم الذاتي",
      "managerEvaluationBox": "تقييم المدير",
      "crossGroupEvaluationBox": "التقييم المتقاطع",
      "freeEvaluationBox": "التقييم الحر",
      "dueDatesBox": "المواعيد النهائية",
      "evaluation": "التقييم",
      "comments": "التعليقات",
      "weight": "الوزن",
      "minCrossGroupEvaluations": "الحد الأدنى للتقييمات المتقاطعة",
      "crossGroupDueDate": "إنشاء مجموعة متقاطعة – ذاتي",
      "evaluationDueDate": "إنشاء مجموعة متقاطعة – المدير",
      "managerSignDueDate": "المجموعة المتقاطعة النهائية – المدير",
      "participantSignDueDate": "تاريخ الإغلاق",
      "processDueDate": "التقييم",
      "beginningReviewDate": "بداية فترة المراجعة",
      "endingReviewDate": "نهاية فترة المراجعة",
      "maxReleaseQuestionnaireDate": "إصدار الاستبيان",
      "createdBy": "أُنشئ بواسطة",
      "createdDate": "تاريخ الإنشاء",
      "modifiedBy": "عُدّل بواسطة",
      "modifiedDate": "تاريخ التعديل",
      "maximumHireDateHelpText": "الحد الأقصى لتاريخ تعيين الموظف للمشاركة، إلا إذا كان الموظف مديراً.",
      "maxPeopleEvaluateAlertHelpText": "إظهار تنبيه بعد وصول الموظف إلى الحد الأقصى لعدد الأشخاص الذين يجب تقييمهم",
      "includeGlobalReportingHelpText": "التضمين في التقارير العالمية",
      "directReportEvaluationHelpText": "تقييم المرؤوس المباشر",
      "directReportCommentsHelpText": "تعليقات المرؤوس المباشر",
      "directReportWeightHelpText": "وزن المرؤوس المباشر",
      "selfEvaluationHelpText": "التقييم الذاتي",
      "selfCommentsHelpText": "التعليقات الذاتية",
      "selfWeightHelpText": "الوزن الذاتي",
      "managerEvaluationHelpText": "تقييم المدير",
      "managerCommentsHelpText": "تعليقات المدير",
      "managerWeightHelpText": "وزن المدير",
      "freeCommentsHelpText": "التعليقات الحرة",
      "freeWeightHelpText": "الوزن الحر",
      "crossGroupEvaluationHelpText": "التقييم المتقاطع",
      "crossGroupCommentsHelpText": "تعليقات التقييم المتقاطع",
      "crossGroupWeightHelpText": "وزن التقييم المتقاطع",
      "minCrossGroupEvaluationsHelpText": "الحد الأدنى لعدد التقييمات المتقاطعة للسماح للمدير بإصدار الاستبيان.",
      "maxReleaseQuestionnaireDateHelpText": "الحد الأقصى للتاريخ الذي يمكن فيه للمدير إصدار الاستبيان",
      "add": "إضافة نموذج",
      "edit": "تعديل النموذج",
      "updateCounters": "تحديث العدادات",
      "detailedResult": "النتيجة التفصيلية",
      "move": {
        "button": "الانتقال إلى {stage}",
        "title": "نقل الخطوة",
        "text": "هل أنت متأكد أنك تريد نقل هذا النموذج إلى مرحلة {stage}؟"
      },
      "duplicate": {
        "button": "تكرار",
        "title": "تكرار النموذج",
        "text": "هل أنت متأكد أنك تريد تكرار هذا النموذج؟"
      },
      "delete": {
        "title": "حذف النموذج",
        "text": "هل أنت متأكد أنك تريد حذف هذا النموذج: {name}؟"
      },
      "formQuestion": {
        "title": "أسئلة النموذج",
        "question": "السؤال",
        "itemOrder": "الترتيب",
        "questionGroup": "مجموعة الأسئلة",
        "add": "إضافة سؤال",
        "edit": "تعديل السؤال",
        "delete": {
          "title": "حذف السؤال",
          "text": "هل أنت متأكد أنك تريد حذف {name} من هذا النموذج؟"
        },
        "messages": {
          "saveSuccess": "تم حفظ سؤال النموذج بنجاح.",
          "saveError": "حدث خطأ أثناء حفظ سؤال النموذج.",
          "deleteSuccess": "تم حذف سؤال النموذج بنجاح.",
          "deleteError": "حدث خطأ أثناء حذف سؤال النموذج.",
          "duplicateQuestion": "تمت إضافة هذا السؤال بالفعل إلى النموذج.",
          "notFound": "لم يتم العثور على سؤال النموذج.",
          "questionNotFound": "لم يتم العثور على السؤال."
        }
      },
      "messages": {
        "notFound": "لم يتم العثور على النموذج.",
        "saveSuccess": "تم حفظ النموذج بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ النموذج.",
        "deleteSuccess": "تم حذف النموذج بنجاح.",
        "deleteError": "حدث خطأ أثناء حذف النموذج.",
        "deleteNotAllowed": "لا يمكن حذف نموذج ليس في مرحلة التحضير.",
        "isInUse": "لا يمكن حذف النموذج لأنه قيد الاستخدام.",
        "atLeastOneMemberEvaluate": "يجب تفعيل نوع مُقيِّم واحد على الأقل (مرؤوس مباشر، ذاتي، مدير، أو مجموعة متقاطعة).",
        "maximumHireDateRequired": "الحد الأقصى لتاريخ التعيين مطلوب.",
        "dueDatesRequired": "جميع المواعيد النهائية مطلوبة.",
        "moveStageSuccess": "تم نقل النموذج إلى المرحلة التالية بنجاح.",
        "moveStageNotAllowed": "لا يمكن نقل نموذج مغلق إلى مرحلة أخرى.",
        "moveStageNotAllowedNoPeople": "لا يحتوي النموذج على أشخاص. للنقل، انتقل إلى صفحة أشخاص النموذج لإضافة أشخاص إلى هذا النموذج.",
        "moveStageNotAllowedNoQuestions": "لا يحتوي النموذج على أسئلة. للنقل، أدرج سؤالاً واحداً على الأقل.",
        "duplicateSuccess": "تم تكرار النموذج بنجاح.",
        "updateCountersSuccess": "تم بدء تحديث العدادات.",
        "detailedResultSuccess": "تم بدء إنشاء النتيجة التفصيلية."
      }
    },
    "formEmailSender": {
      "menuTitle": "مُرسِل بريد النموذج",
      "pageTitle": "مُرسِل بريد النموذج",
      "messages": {
        "emailsSent": "تم إرسال رسائل البريد الإلكتروني بنجاح."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "المدير",
        "directReport": "المرؤوس المباشر",
        "crossGroup": "مجموعة متقاطعة",
        "selfEvaluation": "التقييم الذاتي",
        "freeEvaluation": "التقييم الحر"
      },
      "questionnaireRequestTypes": {
        "default": "افتراضي",
        "manager": "المدير",
        "directReport": "المرؤوس المباشر"
      },
      "questionnaireStatus": {
        "done": "مكتمل",
        "declined": "مرفوض",
        "open": "مفتوح"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "الذاتي، المرؤوسون والمدير",
        "crossGroupPeers": "المجموعة المتقاطعة (الزملاء)",
        "crossGroup": "المجموعات المتقاطعة",
        "freeEvaluation": "التقييم الحر"
      },
      "questionnairesReport": {
        "title": "تقرير الاستبيانات",
        "messages": {
          "confirm": "سيتم تصدير الملف. ستصلك النتائج عبر البريد الإلكتروني قريباً.",
          "success": "تم بدء تصدير تقرير الاستبيانات. ستصلك النتائج عبر البريد الإلكتروني قريباً.",
          "emailNotFound": "لم يتم العثور على البريد الإلكتروني لإجراء التصدير. يرجى التواصل مع المسؤول.",
          "formNotFound": "لم يتم العثور على النموذج لإجراء التصدير. يرجى التواصل مع المسؤول.",
          "exportFailed": "فشل تصدير تقرير الاستبيانات."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "إنشاء مجموعة متقاطعة لنفسي",
        "pageTitle": "إنشاء مجموعة متقاطعة لنفسي",
        "form": "النموذج",
        "infoMessage": " فيما يلي مجموعتك المتقاطعة الافتراضية. أضف موظفين إضافيين ترغب في أن يتم تقييمك من قبلهم. يجب أن يكون لديك خمسة أشخاص على الأقل من نوع \"مجموعة متقاطعة\". سيقوم مديرك بالمراجعة والتحديث وفقاً لذلك وإصدار الاستبيانات.",
        "warningReleasedQuestionnaires": "لا يمكنك إضافة مجموعات متقاطعة لأن مديرك قد أصدر بالفعل استبيانات عنك. يرجى التحدث معه بشأن إضافة استبيانات أخرى.",
        "add": "إضافة موظف",
        "evaluatorPerson": "المُقيِّم",
        "manager": "المدير",
        "type": "النوع",
        "requestType": "طُلب بواسطة",
        "released": "تم الإصدار",
        "status": "الحالة",
        "actions": "الإجراءات",
        "delete": {
          "title": "حذف الاستبيان",
          "text": "هل أنت متأكد أنك تريد حذف هذا الاستبيان؟"
        },
        "messages": {
          "alreadyExists": "يوجد هذا الاستبيان بالفعل لـ {names}. إذا كان لديك أي استفسار، يرجى التحدث مع مديرك.",
          "addSuccess": "تم إنشاء الاستبيانات بنجاح.",
          "deleteSuccess": "تم حذف الاستبيان بنجاح.",
          "invitedPersonWarning": "تمت دعوة {names} بالفعل لتقديم تقييم 360 على {limit} نموذج آخر على الأقل. لتضمينهم في نماذج إضافية، اختر 'حفظ'. إذا لم تكن ملاحظاتهم ضرورية، أغلق دون حفظ واختر شخصاً آخر لتقديم الملاحظات."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "إنشاء مجموعات متقاطعة لفريقي",
        "pageTitle": "إنشاء مجموعات متقاطعة لفريقي",
        "form": "النموذج",
        "manager": "المدير",
        "evaluatedPerson": "المُقيَّم",
        "evaluatorPerson": "المُقيِّم",
        "type": "النوع",
        "released": "تم الإصدار",
        "status": "الحالة",
        "loadCrossGroupDefaults": "تحميل الإعدادات الافتراضية للمجموعة المتقاطعة",
        "unloadCrossGroupDefaults": "إلغاء تحميل الإعدادات الافتراضية للمجموعة المتقاطعة",
        "releaseQuestionnaire": "إصدار الاستبيانات",
        "add": "إضافة استبيان",
        "delete": {
          "title": "حذف الاستبيان",
          "text": "هل أنت متأكد أنك تريد حذف هذا الاستبيان؟"
        },
        "messages": {
          "alreadyExists": "يوجد هذا الاستبيان بالفعل لـ {names}. إذا كان لديك أي استفسار، يرجى التحدث مع مديرك.",
          "createdSuccess": "تم إنشاء الاستبيانات بنجاح.",
          "deletedSuccess": "تم حذف الاستبيان بنجاح.",
          "saveError": "حدث خطأ أثناء حفظ الاستبيان. يرجى المحاولة مرة أخرى.",
          "questionnairesAlreadyExists": "توجد استبيانات بالفعل لـ: {names}.",
          "managerDisabledMessage": "ليس لديك صلاحية الوصول إلى نموذج المجموعة المتقاطعة هذا",
          "releasedSuccess": "تم إصدار الاستبيانات بنجاح.",
          "minCrossGroupEvaluations": "يتم عرض الأشخاص الذين لديهم {value} استبيان مجموعة متقاطعة على الأقل فقط.",
          "noQuestionnairesToRelease": "لا توجد استبيانات لإصدارها. يرجى إضافة استبيان واحد على الأقل للإصدار.",
          "isReadOnlyDueStage": "هذا النموذج للقراءة فقط ولا يمكن تعديله",
          "remoteInstanceWarning": "حدثت مشكلة أثناء تحميل المعلومات عن بُعد.",
          "minimumCrossGroupsNotMet": "لا يملك المرؤوس المباشر الحد الأدنى لعدد المجموعات المتقاطعة ({current}/{minimum})",
          "questionnairesReleased": "تم إصدار الاستبيانات",
          "readyForRelease": "جاهز للإصدار"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "تحميل الإعدادات الافتراضية للمجموعة المتقاطعة",
            "messages": {
              "confirm": "تحذير: يرجى تأكيد رغبتك في تحميل المشاركين الافتراضيين للمجموعة المتقاطعة لجميع المرؤوسين المباشرين.",
              "success": "تم تحميل المشاركين الافتراضيين للمجموعة المتقاطعة بنجاح."
            }
          },
          "unloadDefaults": {
            "title": "إلغاء تحميل الإعدادات الافتراضية للمجموعة المتقاطعة",
            "messages": {
              "confirm": "يرجى تأكيد رغبتك في إلغاء تحميل المشاركين الافتراضيين للمجموعة المتقاطعة لجميع المرؤوسين المباشرين.",
              "success": "تم إلغاء تحميل المشاركين الافتراضيين للمجموعة المتقاطعة بنجاح."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "إنشاء مجموعات متقاطعة لفريقي العالمي",
        "pageTitle": "إنشاء مجموعات متقاطعة لفريقي العالمي"
      },
      "complete": {
        "menuTitle": "إكمال التقييمات",
        "pageTitle": "إكمال التقييمات",
        "form": "النموذج",
        "questionnaireType": "نوع الاستبيان",
        "submit": "إرسال",
        "notApplicable": "غير قابل للتطبيق",
        "declinedCommentPlaceholder": "غير قابل للتطبيق",
        "reopen": "إعادة فتح",
        "status": {
          "new": "لم يبدأ الاستبيان",
          "inProgress": "الاستبيان قيد التنفيذ",
          "completed": "اكتمل الاستبيان"
        },
        "notApplicableTitle": "رفض الاستبيان",
        "reopenTitle": "تأكيد السحب",
        "addFreeEvaluation": "إضافة تقييم حر",
        "personToEvaluate": "الشخص المراد تقييمه",
        "freeEvaluationWarning": "تحتاج التقييمات الحرة إلى موافقة المدراء ولا تُحتسب ضمن درجات تقييم 360 الإجمالية.",
        "messages": {
          "loading": "جارٍ تحميل الاستبيانات...",
          "loadingGlobalQuestionnaires": "جارٍ تحميل الاستبيانات العالمية...",
          "formNotFound": "لم يتم العثور على النموذج.",
          "employeeNotFound": "لم يتم العثور على الموظف.",
          "freeEvaluationNotAllowed": "لا يمكنك إضافة تقييم حر لنفسك أو لمديرك أو لزملائك أو لمرؤوسيك.",
          "alreadyExists": "يوجد بالفعل تقييم لهذا الشخص.",
          "submitConfirmation": "بالنقر على إرسال، سيتم تسجيل تقييم الموظف المعروض. يمكنك سحب التقييمات المُرسلة حتى تتقدم عملية 360 إلى مرحلة توقيع المدير.",
          "summaryValidate": "تحقق من الإجابات ومرر لأسفل للإرسال. النقر على علامة X في الزاوية العلوية اليمنى لن ينهي عملية الإرسال.",
          "submitSuccess": "تم إرسال الاستبيان بنجاح.",
          "questionnaireNotFound": "لم يتم العثور على الاستبيان.",
          "notSubmittedWarningMessage": "لم يتم إرسال هذا الاستبيان بعد ولا يُؤخذ بعين الاعتبار في درجة الموظف.",
          "noQuestionnaires": "ليس لديك أي استبيانات لإكمالها.",
          "selectQuestionnaire": "اختر استبياناً لإكماله.",
          "employeeRateSummary": "تقييم الموظف: ",
          "notApplicable": "إذا لم تكن الشخص المناسب لإكمال تقييم الأداء هذا، يمكنك رفض المسؤولية بعد تقديم سبب.",
          "declineSuccess": "تم رفض الاستبيان بنجاح.",
          "requiredQuestionnairesCompleted": "يمكن إكمال جميع التقييمات المتبقية حسب تقديرك.",
          "allQuestionsRequired": "جميع الأسئلة والتعليقات مطلوبة للإرسال.",
          "confirmReopen": "هل أنت متأكد أنك تريد سحب التقييم الخاص بـ {name}؟",
          "reopenSuccess": "تم إعادة فتح الاستبيان بنجاح.",
          "questionnaireAlreadySubmitted": "تم إرسال هذا الاستبيان بالفعل ولا يمكن تعديله.",
          "addFreeEvaluationSuccess": "تمت إضافة التقييم الحر بنجاح."
        }
      },
      "freeEvaluation": {
        "menuTitle": "مراجعة التقييم الحر",
        "menuTitleGlobal": "مراجعة التقييم الحر العالمي",
        "pageTitle": "مراجعة التقييم الحر",
        "pageTitleGlobal": "مراجعة التقييم الحر العالمي",
        "evaluatedPerson": "المُقيَّم",
        "view": "عرض الاستبيان",
        "infoMessage": "يرجى مراجعة الاستبيانات أدناه واعتماد ما توافق عليه. إذا لم توافق على استبيان، فلا يلزم اتخاذ أي إجراء آخر.",
        "messages": {
          "confirmApproval": "هل أنت متأكد أنك تريد اعتماد الاستبيان؟",
          "approvalSuccess": "تم اعتماد الاستبيان بنجاح.",
          "notFound": "لم يتم العثور على الاستبيان."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "مشاركو النموذج",
        "pageTitle": "مشاركو النموذج",
        "formId": "النموذج",
        "resetTree": "إعادة تعيين الشجرة",
        "resetTreeTitle": "إعادة تعيين الشجرة",
        "resetTreeText": "هل أنت متأكد أنك تريد إعادة تعيين الشجرة؟",
        "addPerson": "إضافة مشارك",
        "changeManager": "تغيير المدير",
        "moveToAnotherManager": "النقل إلى مدير آخر",
        "downloadTemplate": "تنزيل القالب",
        "import": "استيراد",
        "person": "الموظف",
        "currentManager": "المدير الحالي",
        "newManager": "المدير الجديد",
        "messages": {
          "noNodeSelected": "يجب عليك تحديد موظف واحد على الأقل.",
          "saveSuccess": "تم حفظ مشاركي النموذج بنجاح.",
          "resetSuccess": "تمت إعادة تعيين مشاركي النموذج بنجاح.",
          "formNotFound": "لم يتم العثور على النموذج.",
          "selectEmployee": "اختر موظفاً أولاً",
          "addPersonSuccess": "تمت إضافة الشخص بنجاح.",
          "changeManagerSuccess": "تم تغيير المدير بنجاح.",
          "moveToManagerSuccess": "تم نقل الشخص إلى المدير الجديد بنجاح.",
          "managerNotInTree": "المدير المحدد غير موجود في الشجرة.",
          "circularManagerSelection": "لا يمكن نقل موظف إلى أحد مرؤوسيه.",
          "importSuccess": "تم استيراد الملف بنجاح. ستصلك النتائج عبر البريد الإلكتروني قريباً."
        },
        "errors": {
          "formInExecution": "لا يمكن تنفيذ هذا الإجراء لأن النموذج حالياً في مرحلة التنفيذ."
        }
      },
      "resultViewer": {
        "menuTitle": "تقارير PDF المعتمدة",
        "pageTitle": "تقارير PDF المعتمدة",
        "person": "الشخص",
        "personHelpText": "يمكنك تحديد نفسك أو أي من مرؤوسيك المباشرين.",
        "personMultipleInstance": "لا تحدد موظفين من نسخ متعددة. قد تكون النتائج غير صحيحة أو غير مكتملة.",
        "manager": "المدير",
        "form": "النموذج",
        "position": "المنصب",
        "managerFeedback": "ملاحظات المدير",
        "employeeFeedback": "ملاحظات الموظف",
        "pdfReport": "تقرير PDF",
        "pdfReportFreeEvaluation": "PDF التقييم الحر",
        "pdfReportFreeEvaluationNonApproved": "PDF التقييم الحر غير المعتمد",
        "downloadSelected360Report": "تنزيل تقرير 360 المحدد",
        "downloadSelectedFreeEvaluationReport": "تنزيل تقرير التقييم الحر المحدد",
        "downloadSelectedNonApprovedFreeEvaluationReport": "تنزيل تقرير التقييم الحر غير المعتمد المحدد",
        "emailSelected360Report": "تنزيل تقرير 360 المحدد",
        "emailSelectedFreeEvaluationReport": "تنزيل تقرير التقييم الحر المحدد",
        "emailSelectedNonApprovedFreeEvaluationReport": "تنزيل تقرير التقييم الحر غير المعتمد المحدد",
        "bulkEmailQueued": "يتم الآن تجهيز تقاريرك. ستصلك رسالة بريد إلكتروني تحتوي على مرفقات PDF قريباً.",
        "bulkEmailNoSelection": "حدد صفاً واحداً على الأقل.",
        "bulkEmailInvalidSelection": "صف واحد أو أكثر من الصفوف المحددة غير صالح لصلاحيتك.",
        "bulkEmailNoReportForKind": "لا تتضمن الصفوف المحددة هذا النوع من التقارير.",
        "showFeedback": "إظهار الملاحظات",
        "downloadEvaluationSelectOne": "حدد شخصاً أو مديراً واحداً.",
        "validationSelectPersonOrManager": "حدد شخصاً أو مديراً لتشغيل المرشح.",
        "successPdfByEmail": "تم إرسال ملف PDF بنجاح إلى بريدك الإلكتروني."
      },
      "sign": {
        "menuTitle": "توقيع التقييمات المعلّقة",
        "pageTitle": "توقيع التقييمات المعلّقة",
        "menuTitleGlobal": "توقيع التقييمات المعلّقة العالمي",
        "pageTitleGlobal": "توقيع التقييمات المعلّقة العالمي",
        "form": "النموذج",
        "managerOrPerson": "المدير/الشخص",
        "person": "الشخص",
        "pdfReport": "تقرير PDF",
        "pdfReportFreeEvaluation": "تقرير PDF للتقييمات الحرة",
        "sign": "توقيع",
        "signed": "تم التوقيع",
        "signTitle": "توقيع التقييم",
        "managerSign": "توقيع المدير",
        "personSign": "توقيع الموظف",
        "signatureComments": "تعليقات التوقيع",
        "updateComment": "تحديث التعليق",
        "messages": {
          "signedBy": "تم التوقيع بواسطة {name} بتاريخ {date}",
          "signConfirmationManager": "يمكن تقديم أي معلومات إضافية بخصوص عملية الملاحظات مع مرؤوسك المباشر أدناه.",
          "signConfirmationPerson": "بتحديد توقيع، فإنك تؤكد أنك أجريت محادثة ملاحظات مع مديرك حول التقييم.",
          "signConfirmationWarning": "بتحديد توقيع، سيتم إصدار ملف PDF للموظف.",
          "managerSignatureNotAllowed": "لا يمكنك توقيع هذا التقييم لأن المدير قد وقّعه بالفعل.",
          "employeeSignatureNotAllowed": "لا يمكنك توقيع هذا التقييم لأن الشخص قد وقّعه بالفعل.",
          "successMessage": "تم توقيع التقييم بنجاح.",
          "updateCommentSuccessMessage": "تم تحديث التعليق بنجاح.",
          "noComments": "يجب عليك تقديم تعليقات قبل التوقيع."
        }
      }
    }
  },
  "security": {
    "menuTitle": "الأمان",
    "resource": {
      "menuName": "المورد",
      "pageTitle": "المورد",
      "add": "إضافة مورد",
      "edit": "تعديل المورد",
      "delete": {
        "title": "حذف المورد",
        "text": "هل أنت متأكد أنك تريد حذف هذا المورد؟"
      },
      "id": "المعرّف",
      "name": "الاسم",
      "description": "الوصف",
      "resourceType": "نوع المورد",
      "isActive": "نشط",
      "messages": {
        "created": "تم إنشاء المورد بنجاح.",
        "updated": "تم تحديث المورد بنجاح.",
        "deleted": "تم حذف المورد بنجاح.",
        "notFound": "لم يتم العثور على سجل المورد",
        "duplicateName": "يوجد بالفعل مورد بهذا الاسم.",
        "inUse": "سجل المورد قيد الاستخدام. احذف استخداماته أولاً."
      }
    },
    "user": {
      "menuName": "المستخدم",
      "pageTitle": "المستخدم",
      "subgridName": "حساب المستخدم",
      "uniqueId": "المعرّف الفريد",
      "add": "إضافة حساب مستخدم",
      "edit": "تعديل حساب المستخدم",
      "delete": {
        "title": "حذف حساب المستخدم",
        "text": "هل أنت متأكد أنك تريد حذف حساب المستخدم هذا؟"
      },
      "personId": "المعرّف",
      "provider": "المزوّد",
      "userName": "اسم المستخدم",
      "isActive": "نشط",
      "messages": {
        "created": "تم إنشاء حساب المستخدم بنجاح.",
        "updated": "تم تحديث حساب المستخدم بنجاح.",
        "deleted": "تم حذف حساب المستخدم بنجاح.",
        "notFound": "لم يتم العثور على سجل حساب المستخدم",
        "duplicateName": "اسم المستخدم هذا موجود بالفعل."
      }
    },
    "group": {
      "menuName": "المجموعة",
      "pageTitle": "المجموعة",
      "add": "إضافة مجموعة",
      "edit": "تعديل المجموعة",
      "delete": {
        "title": "هل تريد حذف المجموعة؟",
        "text": "هل أنت متأكد أنك تريد حذف هذه المجموعة؟"
      },
      "id": "المعرّف",
      "name": "الاسم",
      "description": "الوصف",
      "isActive": "نشط",
      "overwriteGroups": "استبدال المجموعات",
      "messages": {
        "created": "تم إنشاء المجموعة بنجاح.",
        "updated": "تم تحديث المجموعة بنجاح.",
        "deleted": "تم حذف المجموعة بنجاح.",
        "notFound": "لم يتم العثور على سجل المجموعة",
        "duplicateName": "يوجد بالفعل مجموعة بهذا الاسم.",
        "fileRequired": "الملف مطلوب.",
        "imported": "تم استيراد المجموعات بنجاح"
      }
    },
    "groupPeople": {
      "menuName": "أشخاص المجموعة",
      "pageTitle": "أشخاص المجموعة",
      "add": "إضافة أشخاص المجموعة",
      "edit": "تعديل أشخاص المجموعة",
      "delete": {
        "title": "حذف أشخاص المجموعة",
        "text": "هل أنت متأكد أنك تريد حذف أشخاص المجموعة هذه؟"
      },
      "groupId": "المجموعة",
      "personId": "الشخص",
      "validityStart": "بداية الصلاحية",
      "validityEnd": "نهاية الصلاحية",
      "messages": {
        "created": "تم إنشاء شخص المجموعة بنجاح.",
        "updated": "تم تحديث شخص المجموعة بنجاح.",
        "deleted": "تم حذف شخص المجموعة بنجاح.",
        "notFound": "لم يتم العثور على سجل شخص المجموعة",
        "alreadyExists": "المستخدم يستخدم هذه المجموعة بالفعل."
      }
    },
    "groupPermission": {
      "menuName": "صلاحية المجموعة",
      "pageTitle": "صلاحية المجموعة",
      "add": "إضافة صلاحية مجموعة",
      "edit": "تعديل صلاحية المجموعة",
      "delete": {
        "title": "حذف صلاحية المجموعة",
        "text": "هل أنت متأكد أنك تريد حذف صلاحية المجموعة هذه؟"
      },
      "groupId": "المجموعة",
      "resourceId": "المورد",
      "action": "الإجراء",
      "messages": {
        "created": "تم إنشاء صلاحية المجموعة بنجاح.",
        "updated": "تم تحديث صلاحية المجموعة بنجاح.",
        "deleted": "تم حذف صلاحية المجموعة بنجاح.",
        "notFound": "لم يتم العثور على سجل صلاحية المجموعة",
        "duplicateName": "يوجد بالفعل صلاحية بهذا المورد/الصلاحية."
      }
    }
  },
  "goals": {
    "menuName": "الأهداف",
    "kpi": {
      "menuName": "مؤشرات الأداء"
    },
    "plan": {
      "menuName": "الخطط"
    },
    "target": {
      "menuName": "الأهداف المستهدفة",
      "kpiOwner": {
        "menuName": "الأهداف المستهدفة - مالك مؤشر الأداء"
      }
    },
    "actual": {
      "menuName": "الفعلي",
      "kpiOwner": {
        "menuName": "الفعلي - مالك مؤشر الأداء"
      }
    },
    "discussionNotes": {
      "menuName": "ملاحظات المناقشة"
    },
    "flexibleGoal": {
      "menuName": "الهدف المرن"
    },
    "actionPlan": {
      "menuName": "خطط العمل"
    },
    "library": {
      "menuName": "المكتبة"
    },
    "category": {
      "menuName": "الفئة"
    },
    "PlantArea": {
      "menuName": "منطقة المصنع"
    },
    "clerks": {
      "menuName": "مالكو مؤشرات الأداء"
    },
    "quickEntry": {
      "menuName": "الإدخال السريع السنوي"
    }
  },
  "nineBox": {
    "menuName": "المصفوفة التسعية",
    "nineBoxForm": {
      "menuName": "النموذج"
    },
    "nineBoxFormPeople": {
      "menuName": "مشاركو النموذج"
    },
    "fillTalentTalk": {
      "menuName": "تعبئة حوار المواهب"
    },
    "nineBoxCalibration": {
      "menuName": "المعايرة"
    },
    "fillDevelopmentPlan": {
      "menuName": "تعبئة خطة التطوير"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "لوحة التحكم"
    },
    "request": {
      "newPCF": {
        "menuName": "طلب PCF جديد"
      }
    },
    "requestType": {
      "menuName": "نوع الطلب"
    },
    "approvalGroup": {
      "menuName": "مجموعة الاعتماد"
    },
    "requestStatuses": {
      "menuName": "حالات الطلب"
    },
    "catalog": {
      "menuName": "الكتالوج"
    },
    "immigrationType": {
      "menuName": "نوع الهجرة"
    }
  },
  "merit": {
    "menuName": "العلاوة الاستحقاقية",
    "meritPlanFormList": {
      "menuName": "مشاركو النموذج"
    },
    "meritDashboard": {
      "menuName": "لوحة التحكم"
    },
    "meritPlan": {
      "menuName": "الخطة"
    },
    "awardLetter": {
      "menuName": "خطاب المنحة"
    },
    "meritPlanParticipants": {
      "menuName": "مشاركو الخطة"
    }
  },
  "bonus": {
    "menuName": "المكافأة",
    "bonusIncentiveGroup": {
      "menuName": "مجموعة الحوافز"
    },
    "bonusPlan": {
      "menuName": "الخطة"
    },
    "bonusPlanParticipants": {
      "menuName": "مشاركو الخطة"
    },
    "bonusDashboard": {
      "menuName": "لوحة التحكم"
    },
    "awardLetter": {
      "menuName": "خطاب المنحة"
    },
    "saipAllocation": {
      "menuName": "تخصيص SAIP",
      "messages": {
        "notFound": "لم يتم العثور على تخصيص SAIP.",
        "saveError": "حدث خطأ أثناء حفظ تخصيص SAIP. يرجى المحاولة مرة أخرى.",
        "saveSuccess": "تم حفظ تخصيص SAIP بنجاح.",
        "deleteSuccess": "تم حذف تخصيص SAIP بنجاح.",
        "isInUse": "تخصيص SAIP قيد الاستخدام ولا يمكن حذفه.",
        "duplicateValueCode": "لا يمكن أن تحتوي قيم تخصيص SAIP على رموز مكررة.",
        "duplicateExternalId": "يوجد بالفعل تخصيص SAIP بهذا المعرّف الخارجي.",
        "valuesSumExceeded": "لا يمكن أن يتجاوز مجموع قيم تخصيص SAIP نسبة 100%."
      }
    }
  },
  "cultureTalent": {
    "menuName": "الثقافة والمواهب",
    "culture": {
      "menuName": "برامج الثقافة والمواهب"
    },
    "talent": {
      "menuName": "منصات التدريب"
    }
  },
  "talentMapping": {
    "menuName": "تخطيط المواهب",
    "skills": {
      "menuName": "المهارات"
    },
    "orgChart": {
      "menuName": "الهيكل التنظيمي"
    },
    "myProfile": {
      "menuName": "ملفي الشخصي"
    },
    "degreeTypes": {
      "menuName": "نوع الدرجة العلمية",
      "pageTitle": "نوع الدرجة العلمية",
      "name": "الاسم",
      "isActive": "نشط",
      "add": "إضافة نوع درجة علمية",
      "edit": "تعديل نوع الدرجة العلمية",
      "delete": {
        "title": "حذف نوع الدرجة العلمية",
        "text": "هل أنت متأكد أنك تريد حذف نوع الدرجة العلمية هذا؟"
      },
      "messages": {
        "created": "تم إنشاء نوع الدرجة العلمية بنجاح.",
        "updated": "تم تحديث نوع الدرجة العلمية بنجاح.",
        "deleted": "تم حذف نوع الدرجة العلمية بنجاح.",
        "saveError": "حدث خطأ أثناء حفظ نوع الدرجة العلمية. يرجى المحاولة مرة أخرى.",
        "notFound": "لم يتم العثور على سجل نوع الدرجة العلمية.",
        "inUse": "نوع الدرجة العلمية قيد الاستخدام ولا يمكن حذفه."
      }
    }
  },
  "absenceRequest": {
    "menuName": "طلب الغياب",
    "createRequest": {
      "menuName": "إنشاء طلب"
    },
    "viewManageRequests": {
      "menuName": "طلباتي"
    },
    "calendar": {
      "menuName": "التقويم"
    },
    "pendingRequestsAndHistory": {
      "menuName": "الاعتمادات"
    },
    "manageDirectReportsHours": {
      "menuName": "إدارة الأرصدة"
    },
    "upload": {
      "menuName": "رفع"
    },
    "manageAbsenceProfiles": {
      "menuName": "إدارة ملفات الغياب"
    },
    "manageHolidays": {
      "menuName": "إدارة العطلات"
    },
    "hoursCalculationMatrices": {
      "menuName": "مصفوفات حساب الساعات"
    },
    "manageApprovingDelegate": {
      "menuName": "تفويض الاعتمادات"
    },
    "notification": {
      "menuName": "إشعار الغياب"
    },
    "manageMatrixCategories": {
      "menuName": "إدارة فئات المصفوفة"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "إدارة مصفوفة العطلة المرنة"
    },
    "manageSickMatrix": {
      "menuName": "إدارة مصفوفة الإجازة المرضية"
    }
  },
  "expenseReport": {
    "menuName": "تقارير المصاريف",
    "createExpenses": {
      "menuName": "إنشاء طلب"
    },
    "myExpenses": {
      "menuName": "طلباتي"
    },
    "approvals": {
      "menuName": "المصاريف المطلوب اعتمادها"
    },
    "delegateApprovals": {
      "menuName": "تفويض الاعتمادات"
    },
    "preparers": {
      "menuName": "المُعِدّون"
    },
    "categories": {
      "menuName": "الفئات"
    },
    "distanceRates": {
      "menuName": "أسعار المسافة"
    },
    "generalLedgers": {
      "menuName": "دفاتر الأستاذ العامة"
    },
    "policies": {
      "menuName": "السياسات"
    },
    "projects": {
      "menuName": "المشاريع"
    }
  },
  "salaryExtraPay": {
    "menuName": "أجر اليوم السادس/السابع",
    "createRequest": {
      "menuName": "إنشاء طلب"
    },
    "myRequests": {
      "menuName": "طلباتي"
    },
    "approvals": {
      "menuName": "الاعتمادات"
    },
    "delegateApprovals": {
      "menuName": "تفويض الاعتمادات"
    },
    "locationSetups": {
      "menuName": "إعدادات المواقع"
    },
    "export": {
      "menuName": "تصدير"
    },
    "policies": {
      "menuName": "السياسات"
    },
    "payType": {
      "menuName": "أنواع الأجر"
    },
    "personnelAreaSetups": {
      "menuName": "إعدادات مناطق شؤون الموظفين"
    }
  },
  "developmentPlan": {
    "menuName": "خطة التطوير",
    "planDelegate": {
      "menuName": "مفوّض الخطة"
    },
    "questions": {
      "menuName": "الأسئلة"
    },
    "plans": {
      "menuName": "الخطط"
    },
    "programs": {
      "menuName": "البرامج"
    },
    "notificationSender": {
      "menuName": "مُرسِل الإشعارات"
    },
    "fillDevelopmentPlan": {
      "menuName": "تعبئة خطة التطوير"
    },
    "signEvaluations": {
      "menuName": "توقيع التقييمات"
    },
    "resultViewer": {
      "menuName": "عارض النتائج"
    }
  },
  "survey": {
    "menuName": "الاستبيان",
    "questionCategories": {
      "menuName": "فئات الأسئلة"
    },
    "questions": {
      "menuName": "الأسئلة"
    },
    "ratingScales": {
      "menuName": "مقاييس التقييم"
    },
    "actionPlans": {
      "menuName": "خطة العمل"
    },
    "people": {
      "menuName": "الأشخاص"
    },
    "surveys": {
      "menuName": "نماذج الاستبيان"
    },
    "notificationSender": {
      "menuName": "مُرسِل الإشعارات"
    },
    "dashboard": {
      "menuName": "لوحة التحكم"
    }
  },
  "hourlyPositions": {
    "menuName": "المناصب بالساعة",
    "createRequest": {
      "menuName": "إنشاء طلب"
    },
    "requests": {
      "menuName": "الطلبات"
    },
    "employeeSubgroup": {
      "menuName": "المجموعة الفرعية للموظف"
    },
    "hourlyCatalog": {
      "menuName": "كتالوج العمل بالساعة"
    }
  },
  "vuestic": {
    "search": "بحث",
    "noOptions": "لم يتم العثور على عناصر",
    "ok": "موافق",
    "cancel": "إلغاء",
    "uploadFile": "اختر ملفاً",
    "undo": "تراجع",
    "dropzone": "أفلت الملفات هنا للرفع",
    "fileDeleted": "تم حذف الملف",
    "closeAlert": "إغلاق التنبيه",
    "backToTop": "العودة إلى الأعلى",
    "toggleDropdown": "تبديل القائمة المنسدلة",
    "carousel": "عرض دوّار",
    "goPreviousSlide": "الانتقال إلى الشريحة السابقة",
    "goNextSlide": "الانتقال إلى الشريحة التالية",
    "goSlide": "الانتقال إلى الشريحة {index}",
    "slideOf": "الشريحة {index} من {length}",
    "close": "إغلاق",
    "openColorPicker": "فتح منتقي الألوان",
    "colorSelection": "اختيار اللون",
    "colorName": "اللون {color}",
    "decreaseCounter": "إنقاص العداد",
    "increaseCounter": "زيادة العداد",
    "selectAllRows": "تحديد جميع الصفوف",
    "sortColumnBy": "فرز العمود حسب {name}",
    "selectRowByIndex": "تحديد الصف {index}",
    "resetDate": "إعادة تعيين التاريخ",
    "nextPeriod": "الفترة التالية",
    "switchView": "تبديل العرض",
    "previousPeriod": "الفترة السابقة",
    "removeFile": "إزالة الملف",
    "reset": "إعادة تعيين",
    "pagination": "ترقيم الصفحات",
    "goToTheFirstPage": "الانتقال إلى الصفحة الأولى",
    "goToPreviousPage": "الانتقال إلى الصفحة السابقة",
    "goToSpecificPage": "الانتقال إلى الصفحة {page}",
    "goToSpecificPageInput": "أدخل رقم الصفحة",
    "goNextPage": "الانتقال إلى الصفحة التالية",
    "goLastPage": "الانتقال إلى الصفحة الأخيرة",
    "currentRating": "التقييم الحالي {value} من {max}",
    "voteRating": "تقييم التصويت {value} من {max}",
    "optionsFilter": "مرشح الخيارات",
    "splitPanels": "لوحات مقسّمة",
    "movePaginationLeft": "نقل الترقيم إلى اليسار",
    "movePaginationRight": "نقل الترقيم إلى اليمين",
    "resetTime": "إعادة تعيين الوقت",
    "closeToast": "إغلاق الإشعار",
    "selectedOption": "الخيار المحدد",
    "noSelectedOption": "لم يتم تحديد أي خيار",
    "breadcrumbs": "مسار التنقل",
    "counterValue": "قيمة العداد",
    "selectedDate": "التاريخ المحدد",
    "selectedTime": "الوقت المحدد",
    "progressState": "حالة التقدم",
    "color": "اللون",
    "next": "التالي",
    "back": "رجوع",
    "finish": "إنهاء",
    "step": "خطوة",
    "progress": "التقدم",
    "loading": "جارٍ التحميل",
    "sliderValue": "القيمة الحالية لشريط التمرير هي {value}",
    "switch": "تبديل",
    "inputField": "حقل الإدخال",
    "fileTypeIncorrect": "نوع الملف غير صحيح",
    "select": "اختر خياراً"
  },
  "orgChart": {
    "title": "الهيكل التنظيمي",
    "menuTitle": "الهيكل التنظيمي",
    "menuName": "الهيكل التنظيمي",
    "organization": "المنظمة",
    "directReports": "المرؤوسون المباشرون",
    "showEmployeeDetails": "إظهار تفاصيل الموظف",
    "goUp": "الانتقال إلى المستوى الأعلى",
    "navigateHere": "الانتقال إلى هنا",
    "vacant": "شاغر",
    "legend": {
      "active": "نشط",
      "inactive": "غير نشط",
      "termed": "منتهي الخدمة",
      "vacant": "شاغر"
    },
    "position": "المنصب",
    "plant": "المصنع",
    "businessArea": "مجال العمل",
    "personnelArea": "منطقة شؤون الموظفين",
    "costCenter": "مركز التكلفة",
    "hireDate": "تاريخ التعيين",
    "score360": "درجة تقييم 360",
    "scoreGoals": "درجة الأهداف",
    "score9box": "المصفوفة التسعية",
    "person": "الشخص",
    "employeeType": "نوع الموظف",
    "employeeStatus": "حالة الموظف",
    "status": "الحالة",
    "view": "عرض",
    "viewOptions": {
      "basic": "أساسي",
      "performance": "الأداء",
      "headcount": "عدد الموظفين"
    },
    "headcount": {
      "directTotal": "إجمالي المرؤوسين المباشرين",
      "directSESNE": "SE/SNE المباشر",
      "total": "إجمالي عدد الموظفين",
      "spanOfControl": "نطاق الإشراف",
      "se": "الموظفون براتب",
      "sne": "موظفو SNE",
      "hourly": "الموظفون بالساعة",
      "truck": "موظفو الشاحنات",
      "work": "موظفو العمل"
    },
    "hidePeers": "إخفاء الزملاء",
    "showPeers": "إظهار الزملاء",
    "collapse": "طي",
    "expand": "توسيع",
    "errors": {
      "salariedTypeCannotBeRemoved": "لا يمكن إزالة نوع الموظف براتب.",
      "employeeNotInTree": "هذا الموظف خارج شجرة الهيكل التنظيمي ولا يمكن عرضه."
    }
  }
}
